import './style.scss';
import { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Redirect } from "react-router-dom";
import AuthService from '../../../shared/authService';
import QueryService from '../../../shared/queryService';
import Utils from '../../../shared/utils';
import ConfigService from '../../../shared/configService';
import { IFeature } from '@esri/arcgis-rest-types';
import IReportMainFeature from './models/IReportMainFeature';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { IEditReportState, IGeneralInformationTab, IRestorationPledgeTrackingTab, IRestorationPledgeTrackingDetailsTab, IPrivateSectorSuccessFactorsMonitoringSystem, IPrivateSectorSuccessFactorsPlanningMethodology, IPrivateSectorResultsAndBenefitsItem, ISocioEconomicImpactItem, IPrivateSectorResultsAndBenefitsTab, IPrivateSectorSocioEconomicImpactsTab, ISuccessFactorsPolicyStrategies, IPrivateSectorSuccessFactorsTab, IPrivateSectorSuccessFactorsFinancialFlow, IPrivateSectorSplitUpValues, IReportCountriesIndicators, IPrivateSectorSocioEconomicImpactItem, ICountriesPrivateSectorSuccessFactorsTab, ICountriesPrivateSectorResultsAndBenefitsTab, ICountriesPrivateSectorSplitUpValues, ICountryPrivateSectorResultsAndBenefitsItem } from './models/IEditReportState';
import { IRefTierFeature, IRefPledgeInitiativeFeature, IRefPledgeEcosystemTypeFeature, IRefPledgeImplementFeature, IRefActionIndicatorFeature, IRefImpactIndicatorFeature, IRefRestorationPrinciplesFeature, IRefConfidenceFeature, IRefFinancialSupportFeature, IRefMonitoringTrackedElemFeature, IRefCO2EstimationSystem, IRefCO2RestorationInterventionFeature, IRefRestorationAimsFeature, IRefJobsStakeholdersFeature, IRefInterventionType } from './models/IRefFeature';
import { IExportReportFeature } from './models/IExportReportFeature';
import GeneralInformationTab from './templates/GeneralInformationTab';
import SectorRestorationPledge from './templates/SectorRestorationPledge';
import SectorRestorationPledgeDetails from './templates/SectorRestorationPledgeDetails';
import SectorSuccessFactors from './templates/SectorSuccessFactors';
import SectorResultsAndBenefits from './templates/SectorResultsAndBenefits';
import { ToastContainer, toast } from 'react-toastify';
import { Modal } from 'react-bootstrap';
import LoadingOverlay from 'react-loading-overlay';
import { IRelatedRecordGroup } from '@esri/arcgis-rest-feature-layer';
import { IRefFocalPointFeature } from './models/IRefFeature';
import submitDataLoad from '../../../json/submitJson.json';
import PSPrivacyPopupSplash from '../../splash/PSPrivacyPopupSplash';
import CookieService from '../../../shared/cookieService';
import { saveAs } from "file-saver";
import { util } from 'echarts';

const lookup = require('country-code-lookup');

const SectorEditReport = () => {
  const IsViewUser = window.localStorage.IUCN_VIEW_GROUP === 'ViewOnly' ? true : false;

  const urlParams = new URLSearchParams(window.location.search);
  const reportId: number = Number(urlParams.get('id'));
  const history = useHistory();
  const { t } = useTranslation('sectorreports');
  const XLSX = require('xlsx-js-style');
  let tiers: IRefTierFeature[] = [];
  let pledgeInitiative: IRefPledgeInitiativeFeature[] = [];
  let ecoSystems: IRefPledgeEcosystemTypeFeature[] = [];
  let pledgeImplement: IRefPledgeImplementFeature[] = [];
  let actionIndicator: IRefActionIndicatorFeature[] = [];
  let impactIndicator: IRefImpactIndicatorFeature[] = [];
  let restorationPrinciples: IRefRestorationPrinciplesFeature[] = [];
  let confidenceLevel: IRefConfidenceFeature[] = [];
  let financialSupport: IRefFinancialSupportFeature[] = [];
  let monitoringTrackedElement: IRefMonitoringTrackedElemFeature[] = [];
  let cO2EstimationSystem: IRefCO2EstimationSystem[] = [];
  let cO2RestorationIntervention: IRefCO2RestorationInterventionFeature[] = [];
  let restorationAims: IRefRestorationAimsFeature[] = [];
  let jobStakesholders: IRefJobsStakeholdersFeature[] = [];
  let interventionTypes: IRefInterventionType[] = [];

  // Confirm dialog
  const [exitDialog, setExitDialog] = useState(false);
  const [submitReportDialog, setSubmitReportDialog] = useState(false);
  const isAgreedPrivacy = window.localStorage.IUCN_AGREED_PRIVACY == 'true' ? true : false;
  /**
   * Handle exit dialog
   */
  const handleExitDialogClose = () => setExitDialog(false);
  const handleExitDialogShow = () => setExitDialog(true);
  const handleExitConfirm = () => {
    goToReportsListPage();
    handleExitDialogClose();
  }
  const useForceUpdate = () => {
    const [value, setValue] = useState(0); // integer state
    return () => setValue(value => value + 1); // update state to force render
    // A function that increment 👆🏻 the previous state like here 
    // is better than directly setting `setValue(value + 1)`
  }
  /**
  * Handle submit report dialog
  */
  const handleSubmitReportDialogClose = () => setSubmitReportDialog(false);
  const handleSubmitReportDialogShow = () => {
    const obj: any = { ...localState };

    if (obj) {
      if (window.localStorage.IUCN_AGREED_PRIVACY == 'true') {
        obj.isOpen = false;
        setLocalState(obj);
        setSubmitReportDialog(true);
      }
      else {
        obj.isOpen = true;
        window.localStorage.setItem(CookieService.SESSION_OPEN_AGREED_PRIVACY_OPENED, 'true');
        forceUpdate();
        setLocalState(obj);
      }
    }
  }
  const handleSubmitReportConfirm = () => {
    onSubmit();
    handleSubmitReportDialogClose();
  }

  /**
   * Go to reports list page
   */
  const goToReportsListPage = () => {
    history.push(ConfigService.getConfig().routes?.submissionTool.reports || '');
  }

  /**
   * State
   */
  const [localState, setLocalState] = useState({
    reportLayerIndex: ConfigService.getConfig().agol?.operationalLayers.reportMain.index,
    reportRBLayerIndex: ConfigService.getConfig().agol?.operationalLayers.reportRb.index,
    activitiesPointsLayerIndex: ConfigService.getConfig().agol?.operationalLayers.activitiesPoints.index,
    drafBtnMouseOver: false,
    submitBtnMouseOver: false,
    isSaveDraftLoading: false,
    isSaveJsonLoading: false,
    isSubmitLoading: false,
    isFetchingReportData: false,
    rb_GlobalId: '',
    rb_MainGlobalId: '',
    isExportLoading: false,
    isOpen: false,
    AgreePrivacy: false,
  });

  const [state, setState] = useState<IEditReportState>({
    userLoaded: AuthService.checkConnectedUser(),
    reportLoaded: false,
    report: null,

    generalInfoTab: {
      isActive: true,
      isOK: false,
      emailOK: false
    },

    restorationPledgeTrackingTab: {
      isActive: false,
      isOK: false,
      is_previously_reported: '',
      pledge_start_date: '',
      pledge_end: 0,
      linked_init: '',
      linked_init_other: '',
      links: '',
      current_pledge: '',
      ecosystems: '',
      ecosystems_other: '',
      pledge_implementation: '',
      pledge_implementation_other: '',
      pledge_impl_financial_support: '',
      achievements_learnings: '',
      pledge_fulfil: ''
    },

    restorationPledgeTrackingDetailsTab: {
      isActive: false,
      isOK: false,
      sectorReportCountries: {
        privateSectorReportCountriesIndicators: [],
        deleteCountriesIndicatorObjetIds: []
      }
    },

    privateSectorSuccessFactorsTab: {
      isActive: false,
      isOK: false,
      isDisabled: false,
      isGlobalMode: true,
      policiesAndStrategiesTab: {
        policiesAndStrategies: [],
        deleteObjetIds: []
      },
      privateSectorFinancialFlowsTab: {
        totalDomesticPublicExpenditure: {
          report_id: '',
          type: ConfigService.getConfig().agol.operationalLayers.reportFinancialFlows.totalDomesticPublicExpenditureType
          // OBJECTID: -1,
          // country_name:'',
          // amount: 0,
          // critical_species_fund_percent: 0,
          // tier: '',
          // sources: '',
          // financial_support_used: '',
          // financial_support_used_other: '',
          // financial_support_contribute: '',
          // country_id: ''
        },
        deleteObjetIds: []
      },
      privateSectorTechnicalPlanningTab: {
        privateSectorPlanningMethodologies: [],
        deleteObjetIds: []
      },
      privateSectorMonitoringTab: {
        privateSectorMonitoringSystems: [],
        deleteObjetIds: []
      },
      sectorReportCountries: []
    },

    countriesPrivateSectorSuccessFactorsTab: {
      isActive: false,
      isOK: false,
      report_id: '',
      OBJECTID: -1,
      //isGlobalMode: false,
      gid1: '',
      country_indicator: '',
      action_indicator: '',
      impact_indicator: '',
      policiesAndStrategiesTab: {
        policiesAndStrategies: [],
        deleteObjetIds: []
      },
      privateSectorFinancialFlowsTab: {
        totalDomesticPublicExpenditure: [],
        deleteObjetIds: []
      },
      privateSectorTechnicalPlanningTab: {
        privateSectorPlanningMethodologies: [],
        deleteObjetIds: []
      },
      privateSectorMonitoringTab: {
        privateSectorMonitoringSystems: [],
        deleteObjetIds: []
      },
      sectorReportCountries: []
    },

    countriesPrivateSectorResultsAndBenefitsTab: {
      isActive: false,
      isOK: false,
      isGlobalMode: true,
      countryprivateSectorResultsAndBenefitsItems: [],
      countryInterventionSplitUp: {
        countryPrivateSectorSplitUpValues: [],
        isOK: false,
        deleteRbHaRestoSplitObjetIds: []
      }
    },

    privateSectorResultsAndBenefitsTab: {
      isActive: false,
      isOK: false,
      isGlobalMode: true,
      privateSectorResultsAndBenefitsItems: [],
      interventionSplitUp: {
        privateSectorSplitUpValues: [],
        isOK: false,
        deleteRbHaRestoSplitObjetIds: []
      }
    },

    activitiesUploadTab: {
      isActive: false,
      isOK: false,
      reportHasShapeUploaded: false,
      restoredHectares: 0,
      investments: 0,
      cO2Sequestred: 0,
      jobsCreated: 0,
      activitiesFound: 0,
      activitiesAssociatedToDistrict: 0,
      activitiesFallingInReportZone: 0,
      activitiesFallingOutsideReportZone: 0,
      alreadyUploadedShapefileFeatures: [],
      alreadyUploadedShapefileFeaturesType: '',
      newUploadedShapefileFeatures: [],
      shapefileUploadDate: ''
      , reportingEntityType: 0
    }
  });

  const [stateExport, setStateExport] = useState<IExportReportFeature>({
    generalInfoTab: {
      company_name: t('newReport.generalInfo.companyName'),
      country_headquarter: t('newReport.generalInfo.countryHQ'),
      company_focal_point_position: t('newReport.generalInfo.companyfocalpoint'),
      focal_point_name: t('newReport.generalInfo.companyfocalpointPosition'),
      email: t('newReport.generalInfo.emailAddress'),
      link_website: t('newReport.generalInfo.linkWebsite')
    },

    restorationPledgeTrackingTab: {
      is_previously_reported: t('newReport.restorationPledge.isPreviouslyReported'),
      pledge_start_date: t('newReport.restorationPledge.pledgeStartYear'),
      pledge_end: t('newReport.restorationPledge.pledgeEndDate'),
      linked_init: t('newReport.restorationPledge.pledgeInitiative'),
      linked_init_other: 'Other ongoing initiative',
      links: t('newReport.restorationPledge.pledgeAnnouncementLinks'),
      ecosystems: t('newReport.restorationPledge.pledgeEcosystem'),
      ecosystems_other: 'Other ecosystems',
      pledge_implementation: t('newReport.restorationPledge.pledgeImplement'),
      pledge_implementation_other: 'Other pledge being implemented',
      pledge_impl_financial_support: 'Financial support to the following initiatives and/or on-the-ground restoration partners',
      pledge_fulfil: t('newReport.restorationPledge.pledgeFulfil'),
    },
    restorationPledgeTrackingDetailsTab:
    {
      location_specific: t('newReport.restorationPledgeDetails.locationSpecificData'),
      action_indicators: t('newReport.restorationPledgeDetails.actionIndicatorExport'),
      impact_indicators: t('newReport.restorationPledgeDetails.impactIndicatorsExport')
    },
    privateSectorReportCountriesIndicators:
    {
      country_indicator: 'Country',
      action_indicator: t('newReport.restorationPledgeDetails.actionIndicatorExport'),
      impact_indicator: t('newReport.restorationPledgeDetails.impactIndicatorsExport'),
      location_specific: t('newReport.restorationPledgeDetails.locationSpecificData'),
    },
    PolicyStrategies:
    {
      responsible: t('newReport.successFactors.relevantpoliciesstrategies'),
      links: t('newReport.successFactors.otherInfo'),
      information: t('newReport.successFactors.policiesCitations'),
      country_name: 'Country'
    },
    PlanningMethodology: {
      methodology: t('newReport.successFactors.whichToolsMethodologies'),
      explanation: t('newReport.successFactors.restorationplanning'),
      links: t('newReport.successFactors.relevantCitations'),
      ecosystem_resto_principles: t('newReport.successFactors.ecosystemRestoPrinciples') + t('newReport.successFactors.ecosystemRestoLink') + t('newReport.successFactors.ecosystemRestoPrinciple'),
      //description: '',
      //scale: '',
      //obs_scale: '',
      //landscape_status: '',
      //species_adressed: '',
      //details: '',
      //information: ''

    },
    FinancialFlow: {
      amount: t('newReport.successFactors.amount'),
      tier: t('newReport.successFactors.tier'),
      financial_support_used: t('newReport.successFactors.financialsupportused'),
      financial_support_contribute: t('newReport.successFactors.financialContribution'),
      sources: t('newReport.successFactors.source'),
      //type: '',
      //critical_species_fund_percent: '',
      //financial_support_used_other: '',      
    },
    MonitoringSystem: {
      monitoring_system: t('newReport.successFactors.monitoringtools'),
      track_list: t('newReport.successFactors.metricstools'),
      information: t('newReport.successFactors.monitoringContributed'),
      links: t('newReport.successFactors.monitoringRelevantCitations'),
      //description: '',
      // managing_instit: '',
      //geo_scale: '',
      //other: '',
      //mrv_system: '',
      //links: '',
    },
    AreaOfLandTab: {
      ha_under_resto: t('newReport.resultsAndBenefits.hectareNumber'),
      ha_tier: t('newReport.resultsAndBenefits.dataClassification'),
      ha_links: t('newReport.resultsAndBenefits.relevantCitations'),
      ha_information: t('newReport.resultsAndBenefits.relevantInformation'),
      ha_restoration_data: t('newReport.resultsAndBenefits.restorationHectares'),
      intervention_type_id: t('newReport.resultsAndBenefits.Interventiontype'),
      splitup_value: t('newReport.resultsAndBenefits.Areaunderha'),
      //ha_imp_year: '',
      //relevant_geospatial_data: '',
      //area_restoration_system: '',
      //ha_resto_intervention_link: '',
    },
    ClimateImpactsTab: {
      co2_sequestered: t('newReport.resultsAndBenefits.co2SequesteredLabel'),
      co2_systems: t('newReport.resultsAndBenefits.co2SystemsLabel'),
      co2_tier: t('newReport.resultsAndBenefits.co2level'),
      co2_links: t('newReport.resultsAndBenefits.co2LinksLabel'),
      co2_information: t('newReport.resultsAndBenefits.co2Sequestration'),
      restoration_interventions_aim: t('newReport.resultsAndBenefits.restorationInterventionsAim'),
      co2_restoration_interventions: t('newReport.resultsAndBenefits.carbonReductions'),

      //co2_other: '',
      //co2_contribution: '',
      //co2_other_tool: '',
      //co2_certification: '',
    },
    BiodiversityImpactsTab: {
      bio_protarea_ha: t('newReport.resultsAndBenefits.bioProtAreaHaLabel'),
      bio_nativearea_ha: t('newReport.resultsAndBenefits.bioNativeAreaHaLabel'),
      bio_primarea_ha: t('newReport.resultsAndBenefits.bioPrimAreaHaLabel'),
      bio_intactarea_ha: t('newReport.resultsAndBenefits.bioIntactAreaHaLabel'),
      bio_redlist: t('newReport.resultsAndBenefits.bioRedlistLabel'),
      bio_links: t('newReport.resultsAndBenefits.bioLinksLabel'),
      bio_information: t('newReport.resultsAndBenefits.biodiversityImpacts'),
      //bio_ha_threat_species: '',

    },
    psSocioEconomicImpactItem: {
      eco_type: t('newReport.resultsAndBenefits.ecoTypeExport'),
      eco_jobs: t('newReport.resultsAndBenefits.ecoJobsLabel'),
      eco_other: t('newReport.resultsAndBenefits.socioEconomicBenefits'),
      eco_tiers: t('newReport.resultsAndBenefits.ecoTiersLabel'),
      jobs_stakeholders: t('newReport.resultsAndBenefits.stakeholdersBenefit'),
      eco_links: t('newReport.resultsAndBenefits.relevantCitationsEconomy'),
      //jobs_stakeholders_other: '',       
    }
  });

  /**
   * Report data fetch
   */
  const [fetchReportData, setFetchReportData] = useState({});
  useEffect(() => {
    getReport();
  }, [fetchReportData]);

  useEffect(() => {
    //enableDisableFactorsTab();
  }
    // [state.metadataModalityTab?.report_type,
    // state.metadataModalityTab?.successFactorFinancialFlowOn,
    // state.metadataModalityTab?.successFactorMonitoringOn,
    // state.metadataModalityTab?.successFactorPoliciesInstitOn,
    // state.metadataModalityTab?.successFactorTechPlanningOn]
  );

  /**
   * Get related features
   * @param url 
   * @param relationshipId 
   * @param objectId 
   */
  const getRelatedFeatures = async (url: string, relationshipId: number, objectId: number): Promise<IFeature[]> => {
    try {
      const relPoliciesRecords: IRelatedRecordGroup[] = await QueryService.queryRelatedFeatures(url, relationshipId, [objectId]);

      if (relPoliciesRecords && relPoliciesRecords.length) {
        const relatedRecord: IRelatedRecordGroup | undefined = relPoliciesRecords.find((item: IRelatedRecordGroup) => item.objectId === objectId);

        if (relatedRecord) {
          return Promise.resolve(relatedRecord.relatedRecords || []);
        }
      }

      return Promise.resolve([]);
    } catch (err: any) {
      console.error(err);
      return Promise.reject(err);
    }
  }

  /**
   * Set fetching report data loading on / off
   * @param loading
   */
  const setFetchingReportDataLoading = (loading: boolean) => {
    const obj: any = { ...localState };

    if (obj) {
      obj.isFetchingReportData = loading;
      setLocalState(obj);
    }
  }

  /**
   * Set tiers list
   * @returns
   */
  const setTiersList = async () => {
    try {
      const tierFeatures: IFeature[] = await QueryService.queryReferenceFeatures(ConfigService.getConfig().agol?.referenceTables.REF_TIERS.index);

      tiers = tierFeatures.map((feat: IFeature) => feat.attributes as IRefTierFeature);
      return Promise.resolve();
    }
    catch (err: any) {
      return Promise.reject();
    }
  }

  /**
   * Set Pledge Initiative list
   * @returns
   */
  const setPledgeInitiativeList = async () => {
    try {
      const sectorFilter = "reporting_entity_type = '2' OR reporting_entity_type = '1,2'";
      const initiativeFeature: IFeature[] = await QueryService.queryFilterReferenceFeatures(Utils.getReferenceTableQuery(ConfigService.getConfig().agol.referenceTables.REF_RESTPLEDGE_INITIATIVE.index), sectorFilter, false, '*', '');

      pledgeInitiative = initiativeFeature.map((feat: IFeature) => feat.attributes as IRefPledgeInitiativeFeature);
      return pledgeInitiative;
    }
    catch (err: any) {
      return Promise.reject();
    }
  }

  /**
   * Set Ecosystem list
   * @returns
   */
  const setEcosystemList = async () => {
    try {
      const sectorFilter = "reporting_entity_type = '2' OR reporting_entity_type = '1,2'";
      const ecosystemTypeFeature: IFeature[] = await QueryService.queryFilterReferenceFeatures(Utils.getReferenceTableQuery(ConfigService.getConfig().agol.referenceTables.REF_RESTPLEDGE_ECOSYSTEM_TYPE.index), sectorFilter, false, '*', `${ConfigService.getConfig().agol.referenceTables.REF_RESTPLEDGE_ECOSYSTEM_TYPE.fields.key} ASC`);

      ecoSystems = ecosystemTypeFeature.map((feat: IFeature) => feat.attributes as IRefPledgeEcosystemTypeFeature);
      return ecoSystems;
    }
    catch (err: any) {
      return Promise.reject();
    }
  }

  /**
   * Set pledgImplement list
   * @returns
   */
  const setPledgImplementList = async () => {
    try {
      const sectorFilter = "reporting_entity_type = '2' OR reporting_entity_type = '1,2'";
      const pledgeImplementationFeature: IFeature[] = await QueryService.queryFilterReferenceFeatures(Utils.getReferenceTableQuery(ConfigService.getConfig().agol.referenceTables.REF_PLED_IMPLEMENTATION.index), '', false, '*', '');

      pledgeImplement = pledgeImplementationFeature.map((feat: IFeature) => feat.attributes as IRefPledgeImplementFeature);
      return pledgeImplement;
    }
    catch (err: any) {
      return Promise.reject();
    }
  }

  /**
   * Set action indicator list
   * @returns
   */
  const setActionIndicatorList = async () => {
    try {
      const impactFilter = "1=1";
      const IndicatorFeature = await QueryService.queryFilterReferenceFeatures(
        Utils.getReferenceTableQuery(
          ConfigService.getConfig().agol.referenceTables.REF_ACTION_IMPACT_INDICATORS.index
        ),
        impactFilter,
        false,
        "*",
        ``
      );
      const actionFeature: IFeature[] = IndicatorFeature
        .filter((feat: IFeature) => {
          return feat.attributes[ConfigService.getConfig().agol.referenceTables.REF_ACTION_IMPACT_INDICATORS.fields.indicatortype] === "Action";
        })

      actionIndicator = actionFeature.map((feat: IFeature) => feat.attributes as IRefActionIndicatorFeature);
      return actionIndicator;
    }
    catch (err: any) {
      return Promise.reject();
    }
  }

  /**
   * Set impact indicator list
   * @returns
   */
  const setImpactIndicatorList = async () => {
    try {
      const impactFilter = "1=1";
      const IndicatorFeature = await QueryService.queryFilterReferenceFeatures(
        Utils.getReferenceTableQuery(
          ConfigService.getConfig().agol.referenceTables.REF_ACTION_IMPACT_INDICATORS.index
        ),
        impactFilter,
        false,
        "*",
        ``
      );
      const impactFeature: IFeature[] = IndicatorFeature
        .filter((feat: IFeature) => {
          return feat.attributes[ConfigService.getConfig().agol.referenceTables.REF_ACTION_IMPACT_INDICATORS.fields.indicatortype] === "Impact";
        })

      impactIndicator = impactFeature.map((feat: IFeature) => feat.attributes as IRefActionIndicatorFeature);
      return impactIndicator;
    }
    catch (err: any) {
      return Promise.reject();
    }
  }

  /**
   * Set restorationPrinciples list
   * @returns
   */
  const setrestorationPrinciplesList = async () => {
    try {
      const sectorFilter = "reporting_entity_type = '2' OR reporting_entity_type = '1,2'";
      const restorationPrinciplesFeature: IFeature[] = await QueryService.queryFilterReferenceFeatures(Utils.getReferenceTableQuery(ConfigService.getConfig().agol.referenceTables.REF_PLANNING_ECOSYSTEM.index), '', false, '*', '');

      restorationPrinciples = restorationPrinciplesFeature.map((feat: IFeature) => feat.attributes as IRefRestorationPrinciplesFeature);
      return restorationPrinciples;
    }
    catch (err: any) {
      return Promise.reject();
    }
  }

  /**
   * Set confidenceLevel list
   * @returns
   */
  const setconfidenceLevelList = async () => {
    try {
      const sectorFilter = "reporting_entity_type = '2' OR reporting_entity_type = '1,2'";
      const confidenceDataFeature: IFeature[] = await QueryService.queryFilterReferenceFeatures(Utils.getReferenceTableQuery(ConfigService.getConfig().agol.referenceTables.REF_TIERS.index), sectorFilter, false, '*', '');

      confidenceLevel = confidenceDataFeature.map((feat: IFeature) => feat.attributes as IRefConfidenceFeature);
      return confidenceLevel;
    }
    catch (err: any) {
      return Promise.reject();
    }
  }

  /**
   * Set monitoringTrackedElement list
   * @returns
   */
  const setmonitoringTrackedElementList = async () => {
    try {
      const sectorFilter = "reporting_entity_type = '2' OR reporting_entity_type = '1,2'";
      const monitoringTrackedElemFeatures: IFeature[] = await QueryService.queryFilterReferenceFeatures(Utils.getReferenceTableQuery(ConfigService.getConfig().agol.referenceTables.REF_MONITORING_TRACKED_ELEMENTS.index), sectorFilter, false, '*', `${ConfigService.getConfig().agol.referenceTables.REF_MONITORING_TRACKED_ELEMENTS.fields.key} ASC`);

      monitoringTrackedElement = monitoringTrackedElemFeatures.map((feat: IFeature) => feat.attributes as IRefMonitoringTrackedElemFeature);
      return monitoringTrackedElement;
    }
    catch (err: any) {
      return Promise.reject();
    }
  }

  /**
   * Set cO2EstimationSystem list
   * @returns
   */
  const setcO2EstimationSystemList = async () => {
    try {
      const sectorFilter = "reporting_entity_type = '2' OR reporting_entity_type = '1,2'";
      const cO2EstimationSystemFeatures: IFeature[] = await QueryService.queryFilterReferenceFeatures(Utils.getReferenceTableQuery(ConfigService.getConfig().agol.referenceTables.REF_CO2_ESTIMATION_SYSTEM.index), sectorFilter, false, '*', `${ConfigService.getConfig().agol.referenceTables.REF_CO2_ESTIMATION_SYSTEM.fields.key} ASC`);

      cO2EstimationSystem = cO2EstimationSystemFeatures.map((feat: IFeature) => feat.attributes as IRefCO2EstimationSystem);
      return cO2EstimationSystem;
    }
    catch (err: any) {
      return Promise.reject();
    }
  }

  /**
   * Set financialSupport list
   * @returns
   */
  const setfinancialSupportList = async () => {
    try {
      const sectorFilter = "reporting_entity_type = '2' OR reporting_entity_type = '1,2'";
      const financialSupportFeature: IFeature[] = await QueryService.queryFilterReferenceFeatures(Utils.getReferenceTableQuery(ConfigService.getConfig().agol.referenceTables.REF_FINANCIAL_SUPPORT.index), '', false, '*', '');

      financialSupport = financialSupportFeature.map((feat: IFeature) => feat.attributes as IRefPledgeImplementFeature);
      return financialSupport;
    }
    catch (err: any) {
      return Promise.reject();
    }
  }

  /**
   * Set cO2RestorationIntervention list
   * @returns
   */
  const setcO2RestorationInterventionList = async () => {
    try {
      const sectorFilter = "reporting_entity_type = '2' OR reporting_entity_type = '1,2'";
      const cO2RestorationInterventionFeature: IFeature[] = await QueryService.queryFilterReferenceFeatures(Utils.getReferenceTableQuery(ConfigService.getConfig().agol.referenceTables.REF_CO2_RES_INTERVENTIONS.index), '', false, '*', '');

      cO2RestorationIntervention = cO2RestorationInterventionFeature.map((feat: IFeature) => feat.attributes as IRefCO2RestorationInterventionFeature);
      return cO2RestorationIntervention;
    }
    catch (err: any) {
      return Promise.reject();
    }
  }

  /**
   * Set restorationAims list
   * @returns
   */
  const setrestorationAimsList = async () => {
    try {
      const sectorFilter = "reporting_entity_type = '2' OR reporting_entity_type = '1,2'";
      const restorationAimsFeature: IFeature[] = await QueryService.queryFilterReferenceFeatures(Utils.getReferenceTableQuery(ConfigService.getConfig().agol.referenceTables.REF_CO2_RES_INTERVENTION_AIM.index), '', false, '*', '');

      restorationAims = restorationAimsFeature.map((feat: IFeature) => feat.attributes as IRefRestorationAimsFeature);
      return restorationAims;
    }
    catch (err: any) {
      return Promise.reject();
    }
  }

  /**
   * Set interventionTypes list
   * @returns
   */
  const setinterventionTypesList = async () => {
    try {
      const sectorFilter = "reporting_entity_type = '2' OR reporting_entity_type = '1,2'";
      const interventionTypesFeature: IFeature[] = await QueryService.queryReferenceFeatures(ConfigService.getConfig().agol?.referenceTables.REF_INTERVENTION_TYPE.index);

      interventionTypes = interventionTypesFeature.map((feat: IFeature) => feat.attributes as IRefInterventionType);
      return interventionTypes;
    }
    catch (err: any) {
      return Promise.reject();
    }
  }

  /**
   * Set jobStakesholders list
   * @returns
   */
  const setjobStakesholdersList = async () => {
    try {
      const sectorFilter = "reporting_entity_type = '2' OR reporting_entity_type = '1,2'";
      const jobStakesholdersFeature: IFeature[] = await QueryService.queryFilterReferenceFeatures(Utils.getReferenceTableQuery(ConfigService.getConfig().agol.referenceTables.REF_JOB_STAKEHOLDERS.index), '', false, '*', '');

      jobStakesholders = jobStakesholdersFeature.map((feat: IFeature) => feat.attributes as IRefJobsStakeholdersFeature);
      return jobStakesholders;
    }
    catch (err: any) {
      return Promise.reject();
    }
  }

  /**
   * Get reports list
   */
  const getReport = async () => {
    try {
      if (state.userLoaded) {

        setFetchingReportDataLoading(true);

        // 1) Get layer infos
        await QueryService.getLayerFieldsInfos(localState.reportLayerIndex);
        await QueryService.getLayerFieldsInfos(localState.activitiesPointsLayerIndex);

        // 2) Set tiers
        await setTiersList();

        // 3) Get the report
        const features: IFeature[] = await QueryService.queryFeatures(Utils.getOpLayerQuery(localState.reportLayerIndex), `${ConfigService.getConfig().agol?.operationalLayers.reportMain.fields.objectid} = ${reportId}`, false, '*', `${ConfigService.getConfig().agol?.operationalLayers.reportMain.fields.baselineYear} DESC`);

        if (features && features.length) {
          //4) Get related features
          const objectId: number = features[0].attributes[ConfigService.getConfig().agol?.operationalLayers.reportMain.fields.objectid];

          //4) Get related features
          const reportId: string = features[0].attributes[ConfigService.getConfig().agol?.operationalLayers.reportMain.fields.reportID];
          if (reportId != undefined || reportId != '') {
            localState.rb_MainGlobalId = reportId;
          }

          // 4.1) Report policies          
          const relPoliciesFeatures: IFeature[] = await getRelatedFeatures(Utils.getOpLayerQuery(localState.reportLayerIndex), ConfigService.getConfig().agol?.operationalLayers.reportMain.relationships.reportPolicies, objectId);

          // 4.2) Report financial flows
          const financialFlowsFeatures: IFeature[] = await getRelatedFeatures(Utils.getOpLayerQuery(localState.reportLayerIndex), ConfigService.getConfig().agol?.operationalLayers.reportMain.relationships.reportFinancialFlows, objectId);

          // 4.3) Report technical planning
          const technicalPlanningFeatures: IFeature[] = await getRelatedFeatures(Utils.getOpLayerQuery(localState.reportLayerIndex), ConfigService.getConfig().agol?.operationalLayers.reportMain.relationships.reportTechnicalPlanning, objectId);

          // 4.4) Report monitoring
          const monitoringFeatures: IFeature[] = await getRelatedFeatures(Utils.getOpLayerQuery(localState.reportLayerIndex), ConfigService.getConfig().agol?.operationalLayers.reportMain.relationships.reportMonitoring, objectId);

          //5) Results and benefits

          // 5.1) RB
          const rbFeatures: IFeature[] = await getRelatedFeatures(Utils.getOpLayerQuery(localState.reportLayerIndex), ConfigService.getConfig().agol?.operationalLayers.reportMain.relationships.reportRb, objectId);

          if (rbFeatures.length > 0) {
            localState.rb_GlobalId = rbFeatures[0].attributes.GlobalID;
          }

          // 5.2) RB jobs
          const rbJobs: any = await getRelatedJobs(rbFeatures);

          // 5.2) RB jobs
          const rbValues: any = await getRelatedValues(rbFeatures);

          // REPORT COUNTRIES INDICATORS
          //const reportCountriesIndicatorsFeatures: IFeature[] = await getRelatedFeatures(Utils.getOpLayerQuery(localState.reportLayerIndex), ConfigService.getConfig().agol?.operationalLayers.reportMain.relationships.reportCountriesIndicators, objectId);
          const reportCountriesIndicatorsFeatures: any = await getRelatedCountries(reportId);

          // Fill data
          fillData(features[0] as IReportMainFeature, relPoliciesFeatures, financialFlowsFeatures, technicalPlanningFeatures, monitoringFeatures, rbFeatures, rbJobs, rbValues, reportCountriesIndicatorsFeatures);

          setFetchingReportDataLoading(false);
        } else {
          fillData(null);
        }
      }
    } catch (err: any) {
      setFetchingReportDataLoading(false);
      console.error(err);
    }
  };

  /**
   * Get related result benefits jobs
   * @param rbFeatures
   * @returns
   */
  const getRelatedJobs = async (rbFeatures: IFeature[]) => {
    try {
      const rbJobs: any = {};

      if (rbFeatures && rbFeatures.length) {
        const res = await Promise.all(rbFeatures.map(async (feat: IFeature) => {
          return await getRelatedFeatures(Utils.getOpLayerQuery(localState.reportRBLayerIndex),
            ConfigService.getConfig().agol?.operationalLayers.reportMain.relationships.reportRbJobs,
            feat.attributes.OBJECTID);
        }));

        if (res && res.length) {
          rbFeatures.forEach(async (feat: IFeature, i: number) => {
            if (res[i]) {
              rbJobs[feat.attributes.GlobalID] = res[i];
            }
          });
        }
      }

      return Promise.resolve(rbJobs);
    }
    catch (err: any) {
      return Promise.reject(err);
    }
  }

  /**
   * Get related result benefits jobs
   * @param rbFeatures
   * @returns
   */
  const getRelatedValues = async (rbFeatures: IFeature[]) => {
    try {
      let rbJobs: any[] = [];

      if (rbFeatures && rbFeatures.length) {
        const res = await Promise.all(rbFeatures.map(async (feat: IFeature) => {
          return await getRelatedFeatures(Utils.getOpLayerQuery(localState.reportRBLayerIndex),
            ConfigService.getConfig().agol?.operationalLayers.reportMain.relationships.reportRbHaRestoSplit,
            feat.attributes.OBJECTID);
        }));

        if (res && res.length) {
          rbFeatures.forEach((feat: IFeature, i: number) => {
            res[i].forEach((x: any, num: number) => {
              //if(x[num]){
              rbJobs.push(x);
              //}
            })
            // if (res[i]) {              
            //   //rbJobs[feat.attributes.GlobalID] = res[i];
            //   rbJobs.push(res[i][0]);
            // }
          });
        }
      }

      return Promise.resolve(rbJobs);
    }
    catch (err: any) {
      return Promise.reject(err);
    }
  }

  const getRelatedCountries = async (reportId: string) => {
    try {
      let rbJobs: any = {};

      if (reportId) {
        const where = "report_id='" + reportId + "'";
        rbJobs = await QueryService.queryFeatures(Utils.getOpLayerQuery(ConfigService.getConfig().agol.operationalLayers.reportCountriesIndicators.index), where, false, '*')

      }

      return Promise.resolve(rbJobs);
    }
    catch (err: any) {
      return Promise.reject(err);
    }
  }

  /**
   * Get success factors policie from features
   * @param features
   * @returns
   */
  const getSuccessFactorsPolicies = (features: IFeature[]): ISuccessFactorsPolicyStrategies[] => {
    return features.map((feat: IFeature, i: number) => {
      return {
        isActive: i === 0,
        OBJECTID: feat.attributes.OBJECTID,
        report_id: feat.attributes.report_id,
        name: feat.attributes.name,
        information: Utils.fetchLinkFormat(feat.attributes.information),
        responsible: Utils.fetchLinkFormat(feat.attributes.responsible),
        links: Utils.fetchLinkFormat(feat.attributes.links),
        country_id: feat.attributes.country_id,
        country_name: feat.attributes.country_name
      }
    });
  }

  /**
   * getSuccessCountriesIndicators
   * @param features
   * @returns
   */
  const getSuccessCountriesIndicators = (features: IFeature[], reportCountries: any = {}): IReportCountriesIndicators[] => {
    return features.map((feat: IFeature, i: number) => {
      return {
        isOK: false,
        isActive: i === 0,
        OBJECTID: feat.attributes.OBJECTID,
        report_id: feat.attributes.report_id,
        country_indicator: feat.attributes.country_indicator,
        country_id: feat.attributes.country_id,
        action_indicator: feat.attributes.action_indicator,
        impact_indicator: feat.attributes.impact_indicator
      }
    });
  }

  /**
   * Get success factors policie from features
   * @param features
   * @returns
   */
  const getSplitData = (features: IFeature[], rbValues: any = {}): IPrivateSectorSplitUpValues[] => {
    return rbValues.map((feat: IFeature, i: number) => {
      return {
        isOK: false,
        isActive: i === 0,
        OBJECTID: feat.attributes.OBJECTID,
        resto_split_id: feat.attributes.resto_split_id,
        report_rb_id: feat.attributes.report_rb_id,
        ecosystem_id: feat.attributes.ecosystem_id,
        intervention_type_id: feat.attributes.intervention_type_id,
        splitup_value: feat.attributes.splitup_value,
        country_id: feat.attributes.country_id,
        country_name: feat.attributes.country_name
      }
    });
  }
  const getCountrySplitData = (features: IFeature[], rbValues: any = {}): ICountriesPrivateSectorSplitUpValues[] => {
    return rbValues.map((feat: IFeature, i: number) => {
      return {
        isOK: false,
        isActive: i === 0,
        OBJECTID: feat.attributes.OBJECTID,
        resto_split_id: feat.attributes.resto_split_id,
        report_rb_id: feat.attributes.report_rb_id,
        ecosystem_id: feat.attributes.ecosystem_id,
        intervention_type_id: feat.attributes.intervention_type_id,
        splitup_value: feat.attributes.splitup_value,
        country_id: feat.attributes.country_id,
        country_name: feat.attributes.country_name
      }
    });
  }

  /**
     * Get success factors financialflows from features
     * @param features
     * @returns
     */
  const getSuccessFactorsFinancialFlows = (features: IFeature[]): IPrivateSectorSuccessFactorsFinancialFlow[] => {
    return features.map((feat: IFeature, i: number) => {
      return {
        isActive: i === 0,
        OBJECTID: feat.attributes.OBJECTID,
        type: feat.attributes.type,
        report_id: feat.attributes.report_id,
        amount: feat.attributes.amount,
        tier: feat.attributes.tier,
        financial_support_used: feat.attributes.financial_support_used,
        financial_support_used_Other: feat.attributes.financial_support_used_Other,
        financial_support_contribute: Utils.fetchLinkFormat(feat.attributes.financial_support_contribute),
        sources: Utils.fetchLinkFormat(feat.attributes.sources),
        country_name: feat.attributes.country_name,
        country_id: feat.attributes.country_id
      }
    })
  }


  /**
   * Get success factors planning methodologies from features
   * @param features
   * @returns
   */
  const getSuccessFactorsPlanningMethodologies = (features: IFeature[]): IPrivateSectorSuccessFactorsPlanningMethodology[] => {
    return features.map((feat: IFeature, i: number) => {
      return {
        isActive: i === 0,
        OBJECTID: feat.attributes.OBJECTID,
        report_id: feat.attributes.report_id,
        methodology: Utils.fetchLinkFormat(feat.attributes.methodology),
        description: feat.attributes.description,
        //scale: feat.attributes.scale,
        //obs_scale: feat.attributes.obs_scale,
        landscape_status: feat.attributes.landscape_status,
        explanation: Utils.fetchLinkFormat(feat.attributes.explanation),
        //species_adressed: feat.attributes.species_adressed,
        details: feat.attributes.details,
        links: Utils.fetchLinkFormat(feat.attributes.links),
        information: feat.attributes.information,
        ecosystem_resto_principles: feat.attributes.ecosystem_resto_principles,
        country_id: feat.attributes.country_id,
        country_name: feat.attributes.country_name
      }
    })
  }

  /**
   * Get success factors monitoring systems from features
   * @param features
   * @returns
   */
  const getSuccessFactorsMonitoringSystems = (features: IFeature[]): IPrivateSectorSuccessFactorsMonitoringSystem[] => {
    return features.map((feat: IFeature, i: number) => {
      return {
        isActive: i === 0,
        OBJECTID: feat.attributes.OBJECTID,
        report_id: feat.attributes.report_id,
        monitoring_system: Utils.fetchLinkFormat(feat.attributes.monitoring_system),
        description: feat.attributes.description,
        link: feat.attributes.link,
        managing_instit: feat.attributes.managing_instit,
        geo_scale: feat.attributes.geo_scale,
        track_list: feat.attributes.track_list,
        other: feat.attributes.other,
        mrv_system: feat.attributes.mrv_system,
        information: Utils.fetchLinkFormat(feat.attributes.information),
        links: Utils.fetchLinkFormat(feat.attributes.links),
        country_id: feat.attributes.country_id,
        country_name: feat.attributes.country_name
      }
    })
  }

  /**
   * Get results and benefits from features
   * @param features
   * @param rbJobs
   * @returns
   */
  const geResultsAndBenefits = (features: IFeature[], rbJobs: any = {}): IPrivateSectorResultsAndBenefitsItem[] => {
    return features.map((feat: IFeature, i: number) => {
      const objectId: number = feat.attributes.OBJECTID;
      const globalId: string = feat.attributes.GlobalID;

      const outRb: IPrivateSectorResultsAndBenefitsItem = {
        isActive: i === 0,
        isOK: false,
        OBJECTID: objectId,
        report_id: feat.attributes.report_id,
        name0: feat.attributes.NAME_0,
        gid0: feat.attributes.GID_0,
        name1: feat.attributes.NAME_1,
        gid1: feat.attributes.GID_1,
        name2: feat.attributes.NAME_2,
        gid2: feat.attributes.GID_2,

        privateSectorAreaOfLandTab: {
          isOK: false,
          ha_intervention_types: feat.attributes.ha_intervention_types,
          ha_under_resto: feat.attributes.ha_under_resto,
          ha_imp_year: feat.attributes.ha_imp_year,
          ha_tier: feat.attributes.ha_tier,
          ha_links: (feat.attributes.ha_links != undefined && feat.attributes.ha_links != null ? Utils.fetchLinkFormat(feat.attributes.ha_links.replace('<p></p><br>', '').trim()) : feat.attributes.ha_links),
          ha_information: Utils.fetchLinkFormat(feat.attributes.ha_information),
          ha_restoration_data: feat.attributes.ha_restoration_data,
          relevant_geospatial_data: feat.attributes.relevant_geospatial_data,
          area_restoration_system: Utils.fetchLinkFormat(feat.attributes.area_restoration_system),
          ha_resto_intervention_link: feat.attributes.ha_resto_intervention_link
        },


        privateSectorClimateImpactsTab: {
          isOK: false,
          co2_sequestered: feat.attributes.co2_sequestered,
          co2_systems: feat.attributes.co2_systems,
          co2_tier: feat.attributes.co2_tier,
          co2_other: feat.attributes.co2_other,
          co2_contribution: feat.attributes.co2_contribution,
          co2_links: Utils.fetchLinkFormat(feat.attributes.co2_links),
          co2_information: Utils.fetchLinkFormat(feat.attributes.co2_information),
          restoration_interventions_aim: feat.attributes.restoration_interventions_aim,
          co2_restoration_interventions: feat.attributes.co2_restoration_interventions,
          co2_other_tool: feat.attributes.co2_other_tool,
          co2_certification: feat.attributes.co2_certification
        },

        privateSectorBiodiversityImpactsTab: {
          isOK: false,
          bio_ha_threat_species: feat.attributes.bio_ha_threat_species,
          bio_protarea_ha: feat.attributes.bio_protarea_ha,
          bio_nativearea_ha: feat.attributes.bio_nativearea_ha,
          bio_primarea_ha: feat.attributes.bio_primarea_ha,
          bio_intactarea_ha: feat.attributes.bio_intactarea_ha,
          bio_redlist: Utils.fetchLinkFormat(feat.attributes.bio_redlist),
          bio_links: Utils.fetchLinkFormat(feat.attributes.bio_links),
          bio_information: feat.attributes.bio_information
        },

        sectorReportCountries: []
      };

      // socioEconomicImpacts
      if (rbJobs && rbJobs[globalId]) {
        const relatedJobs: IFeature[] = rbJobs[globalId];

        outRb.privateSectorSocioEconomicImpactsTab = {
          isOK: false,
          job_type: relatedJobs.length == 0 ? '1' : relatedJobs[0].attributes[ConfigService.getConfig().agol.operationalLayers.reportRbJobs.fields.job_type]
        }

        relatedJobs.forEach((feat: IFeature) => {
          const ecoType: string = feat.attributes[ConfigService.getConfig().agol.operationalLayers.reportRbJobs.fields.ecoType];

          switch (ecoType) {
            case ConfigService.getConfig().agol.operationalLayers.reportRbJobs.seasonalCasualOccasionalType:
              outRb.privateSectorSocioEconomicImpactsTab!.psSeasonalCasualOccasional = feat.attributes as IPrivateSectorSocioEconomicImpactItem;
              break;

            // case ConfigService.getConfig().agol.operationalLayers.reportRbJobs.shortTermType:
            //   outRb.privateSectorSocioEconomicImpactsTab!.shortTerm = feat.attributes as ISocioEconomicImpactItem;
            //   break;

            case ConfigService.getConfig().agol.operationalLayers.reportRbJobs.longTermType:
              outRb.privateSectorSocioEconomicImpactsTab!.psLongTerm = feat.attributes as IPrivateSectorSocioEconomicImpactItem;
              break;

            // case ConfigService.getConfig().agol.operationalLayers.reportRbJobs.unspecifiedType:
            //   outRb.privateSectorSocioEconomicImpactsTab!.unspecified = feat.attributes as ISocioEconomicImpactItem;
            //   break;
          }
        });

        // 1) seasonalCasualOccasional
        if (!outRb.privateSectorSocioEconomicImpactsTab.psSeasonalCasualOccasional) {
          outRb.privateSectorSocioEconomicImpactsTab.psSeasonalCasualOccasional = {
            OBJECTID: -1,
            report_rb_id: globalId,
            eco_type: ConfigService.getConfig().agol.operationalLayers.reportRbJobs.seasonalCasualOccasionalType
          };
        }

        // // 2) shortTerm
        // if (!outRb.privateSectorSocioEconomicImpactsTab.shortTerm) {
        //   outRb.privateSectorSocioEconomicImpactsTab!.shortTerm = {
        //     OBJECTID: -1,
        //     report_rb_id: globalId,
        //     eco_type: ConfigService.getConfig().agol.operationalLayers.reportRbJobs.shortTermType
        //   };
        // }

        // 3) longTerm
        if (!outRb.privateSectorSocioEconomicImpactsTab.psLongTerm) {
          outRb.privateSectorSocioEconomicImpactsTab!.psLongTerm = {
            OBJECTID: -1,
            report_rb_id: globalId,
            eco_type: ConfigService.getConfig().agol.operationalLayers.reportRbJobs.longTermType
          };
        }

        // // 4 ) unspecified
        // if (!outRb.privateSectorSocioEconomicImpactsTab.unspecified) {
        //   outRb.privateSectorSocioEconomicImpactsTab!.unspecified = {
        //     OBJECTID: -1,
        //     report_rb_id: globalId,
        //     eco_type: ConfigService.getConfig().agol.operationalLayers.reportRbJobs.unspecifiedType
        //   };
        // }
      }

      return outRb;
    });
  }


  /**
   * Fill data
   * @param report
   * @param relPoliciesFeatures
   * @param financialFlowsFeatures
   */
  const fillData = (
    report: IReportMainFeature | null,
    relPoliciesFeatures: IFeature[] = [],
    financialFlowsFeatures: IFeature[] = [],
    technicalPlanningFeatures: IFeature[] = [],
    monitoringFeatures: IFeature[] = [],
    rbFeatures: IFeature[] = [],
    rbJobs: any = {},
    rbValues: any = {},
    reportCountriesIndicatorsFeatures: any = {}
  ) => {
    const reportState: IEditReportState = { ...state };

    if (report) {
      reportState.report = report;

      // 1) General Information
      fillGeneralInfoData(report);

      // 2) Pledge Implementation Tracking Summary
      fillRestorationPledgeData(report);

      // 3) Pledge Implementation Tracking Details
      fillRestorationPledgeDetail(report);

      // 4) Success factors
      fillSuccessFactorsData(report, relPoliciesFeatures, financialFlowsFeatures, technicalPlanningFeatures, monitoringFeatures);

      // 5) Results and benefits
      fillResultsAndBenefits(rbFeatures, rbJobs);

      fillSplitValues(rbFeatures, rbValues);
      // fillSplitValues(report);
      fillCountriesIndicators(reportCountriesIndicatorsFeatures);
    }

    // Is report loaded
    reportState.reportLoaded = true;

    setState(reportState);
  }

  /**
   * Fill Metatdata / Modalities Data
   * @param report 
   * @param relPoliciesFeatures 
   */
  const fillGeneralInfoData = (report: IReportMainFeature | null) => {
    const reportState: IEditReportState = { ...state };

    if (report) {
      reportState.generalInfoTab!.company_name = report.attributes.company_name;
      reportState.generalInfoTab!.country_headquarter = report.attributes.country_headquarter;
      reportState.generalInfoTab!.focal_point_name = report.attributes.focal_point_name;
      reportState.generalInfoTab!.company_focal_point_position = report.attributes.company_focal_point_position;
      reportState.generalInfoTab!.email = report.attributes.email;
      reportState.generalInfoTab!.ps_report_type = report.attributes.ps_report_type;
      reportState.generalInfoTab!.link_website = Utils.fetchLinkFormat(report.attributes.link_website);
      validateGeneralInfoData(reportState.generalInfoTab);
    }
  }


  /**
   * Fill restoration pledge data
   * @param report
   */
  const fillRestorationPledgeData = (report: IReportMainFeature | null) => {
    const reportState: IEditReportState = { ...state };

    if (report) {
      reportState.restorationPledgeTrackingTab!.pledge_start_date = report.attributes.pledge_start_date;

      if (report.attributes.pledge_end) {
        reportState.restorationPledgeTrackingTab!.pledge_end = report.attributes.pledge_end;
      }
      reportState.restorationPledgeTrackingTab!.linked_init = report.attributes.linked_init;
      reportState.restorationPledgeTrackingTab!.linked_init_other = report.attributes.linked_init_other;
      reportState.restorationPledgeTrackingTab!.links = Utils.fetchLinkFormat(report.attributes.links);
      reportState.restorationPledgeTrackingTab!.current_pledge = report.attributes.current_pledge;
      reportState.restorationPledgeTrackingTab!.ecosystems = report.attributes.ecosystems;
      reportState.restorationPledgeTrackingTab!.ecosystems_other = report.attributes.ecosystems_other;
      reportState.restorationPledgeTrackingTab!.pledge_implementation = report.attributes.pledge_implementation;
      reportState.restorationPledgeTrackingTab!.pledge_implementation_other = report.attributes.pledge_implementation_other;
      reportState.restorationPledgeTrackingTab!.pledge_impl_financial_support = report.attributes.pledge_impl_financial_support;
      reportState.restorationPledgeTrackingTab!.achievements_learnings = report.attributes.achievements_learnings;
      reportState.restorationPledgeTrackingTab!.pledge_fulfil = report.attributes.pledge_fulfil;
      reportState.restorationPledgeTrackingTab!.is_previously_reported = report.attributes.is_previously_reported;
      validateRestorationPledgeTrackingData(reportState.restorationPledgeTrackingTab);
    }
  }

  /**
   * Fill restoration pledge tracking details
   * @param report
   */
  const fillRestorationPledgeDetail = (report: IReportMainFeature | null) => {
    const reportState: IEditReportState = { ...state };

    if (report) {
      reportState.restorationPledgeTrackingDetailsTab!.location_specific = report.attributes.location_specific?.toString() !== "1" ? "0" : report.attributes.location_specific?.toString();
      reportState.restorationPledgeTrackingDetailsTab!.action_indicators = report.attributes.action_indicators;
      if (report.attributes.impact_indicators == null) {
        reportState.restorationPledgeTrackingDetailsTab!.impact_indicators = '5';
      }
      else if ((report.attributes.impact_indicators?.indexOf('5')) === -1) {
        reportState.restorationPledgeTrackingDetailsTab!.impact_indicators = report.attributes.impact_indicators?.concat(',5');
      }
      else {
        reportState.restorationPledgeTrackingDetailsTab!.impact_indicators = report.attributes.impact_indicators;
      }

      validateRestorationPledgeTrackingDetailData(reportState.restorationPledgeTrackingDetailsTab);
    }
  }

  /**
   * Fill succes factors data
   * @param report
   * @param relPoliciesFeatures
   */
  const fillSuccessFactorsData = (
    report: IReportMainFeature | null,
    relPoliciesFeatures: IFeature[] = [],
    financialFlowsFeatures: IFeature[] = [],
    technicalPlanningFeatures: IFeature[] = [],
    monitoringFeatures: IFeature[] = []
  ) => {
    const reportState: IEditReportState = { ...state };

    if (report) {
      // 1) Policies
      if (relPoliciesFeatures && relPoliciesFeatures.length) {
        const successFactorsPolicies: ISuccessFactorsPolicyStrategies[] = getSuccessFactorsPolicies(relPoliciesFeatures);
        successFactorsPolicies?.map((policies: ISuccessFactorsPolicyStrategies) => {
          if (policies.country_id == null || policies.country_id === '') {
            reportState.privateSectorSuccessFactorsTab!.policiesAndStrategiesTab!.policiesAndStrategies.push(policies);
          }
          else {
            reportState.countriesPrivateSectorSuccessFactorsTab!.policiesAndStrategiesTab!.policiesAndStrategies.push(policies);
          }
        })

        if (reportState.privateSectorSuccessFactorsTab?.policiesAndStrategiesTab?.policiesAndStrategies != undefined && reportState.privateSectorSuccessFactorsTab?.policiesAndStrategiesTab?.policiesAndStrategies?.length > 0) {
          reportState.privateSectorSuccessFactorsTab!.policiesAndStrategiesTab.deleteObjetIds = successFactorsPolicies ? successFactorsPolicies?.map((p: ISuccessFactorsPolicyStrategies) => { return p.OBJECTID; }) : [];
        }
        if (reportState.countriesPrivateSectorSuccessFactorsTab?.policiesAndStrategiesTab?.policiesAndStrategies != undefined && reportState.countriesPrivateSectorSuccessFactorsTab?.policiesAndStrategiesTab?.policiesAndStrategies?.length > 0) {
          reportState.countriesPrivateSectorSuccessFactorsTab!.policiesAndStrategiesTab.deleteObjetIds = successFactorsPolicies ? successFactorsPolicies?.map((p: ISuccessFactorsPolicyStrategies) => { return p.OBJECTID; }) : [];
        }
      }
      if (technicalPlanningFeatures && technicalPlanningFeatures.length) {
        const planningMethodologies: IPrivateSectorSuccessFactorsPlanningMethodology[] = getSuccessFactorsPlanningMethodologies(technicalPlanningFeatures);
        planningMethodologies?.map((planMetho: IPrivateSectorSuccessFactorsPlanningMethodology) => {
          if (planMetho.country_id == null || planMetho.country_id === '') {
            reportState.privateSectorSuccessFactorsTab!.privateSectorTechnicalPlanningTab!.privateSectorPlanningMethodologies.push(planMetho);
          }
          else {
            reportState.countriesPrivateSectorSuccessFactorsTab!.privateSectorTechnicalPlanningTab!.privateSectorPlanningMethodologies.push(planMetho);
          }
        })

        if (reportState.privateSectorSuccessFactorsTab?.privateSectorTechnicalPlanningTab?.privateSectorPlanningMethodologies != undefined && reportState.privateSectorSuccessFactorsTab?.privateSectorTechnicalPlanningTab?.privateSectorPlanningMethodologies?.length > 0) {
          reportState.privateSectorSuccessFactorsTab!.privateSectorTechnicalPlanningTab.deleteObjetIds = planningMethodologies ? planningMethodologies?.map((p: IPrivateSectorSuccessFactorsPlanningMethodology) => { return p.OBJECTID; }) : [];
        }
        if (reportState.countriesPrivateSectorSuccessFactorsTab?.privateSectorTechnicalPlanningTab?.privateSectorPlanningMethodologies != undefined && reportState.countriesPrivateSectorSuccessFactorsTab?.privateSectorTechnicalPlanningTab?.privateSectorPlanningMethodologies?.length > 0) {
          reportState.countriesPrivateSectorSuccessFactorsTab!.privateSectorTechnicalPlanningTab.deleteObjetIds = planningMethodologies ? planningMethodologies?.map((p: IPrivateSectorSuccessFactorsPlanningMethodology) => { return p.OBJECTID; }) : [];
        }
      }

      // 2) FinancialFlows            
      if (financialFlowsFeatures) {
        //let arrFinancialFlows: any[]=[];
        //const financialFlows = getSuccessFactorsFinancialFlows(report, financialFlowsFeatures);
        const financialFlows = getSuccessFactorsFinancialFlows(financialFlowsFeatures);
        //arrFinancialFlows.push(financialFlows);

        financialFlows?.map((fun: IPrivateSectorSuccessFactorsFinancialFlow) => {
          if (fun.country_id == '' || fun.country_id === null) {
            reportState.privateSectorSuccessFactorsTab!.privateSectorFinancialFlowsTab!.totalDomesticPublicExpenditure = fun;
          }
          else {
            reportState.countriesPrivateSectorSuccessFactorsTab!.privateSectorFinancialFlowsTab!.totalDomesticPublicExpenditure!.push(fun);
          }
        })

        // if(reportState.countriesPrivateSectorSuccessFactorsTab?.privateSectorFinancialFlowsTab?.totalDomesticPublicExpenditure != undefined && reportState.countriesPrivateSectorSuccessFactorsTab?.privateSectorFinancialFlowsTab?.totalDomesticPublicExpenditure?.length >0 )
        // {
        //   reportState.countriesPrivateSectorSuccessFactorsTab!.privateSectorFinancialFlowsTab.deleteObjetIds = financialFlows ? financialFlows?.map((p: IPrivateSectorSuccessFactorsFinancialFlow) => { return p.OBJECTID; }) : [];
        // } 
      }


      if (monitoringFeatures && monitoringFeatures.length) {
        const monitoringSystems: IPrivateSectorSuccessFactorsMonitoringSystem[] = getSuccessFactorsMonitoringSystems(monitoringFeatures);
        monitoringSystems?.map((systems: IPrivateSectorSuccessFactorsMonitoringSystem) => {
          if (systems.country_id == null || systems.country_id === '') {
            reportState.privateSectorSuccessFactorsTab!.privateSectorMonitoringTab!.privateSectorMonitoringSystems.push(systems);
          }
          else {
            reportState.countriesPrivateSectorSuccessFactorsTab!.privateSectorMonitoringTab!.privateSectorMonitoringSystems.push(systems);
          }
        })

        if (reportState.privateSectorSuccessFactorsTab?.privateSectorMonitoringTab?.privateSectorMonitoringSystems != undefined && reportState.privateSectorSuccessFactorsTab?.privateSectorMonitoringTab?.privateSectorMonitoringSystems?.length > 0) {
          reportState.privateSectorSuccessFactorsTab!.privateSectorMonitoringTab.deleteObjetIds = monitoringSystems ? monitoringSystems?.map((p: IPrivateSectorSuccessFactorsMonitoringSystem) => { return p.OBJECTID; }) : [];
        }
        if (reportState.countriesPrivateSectorSuccessFactorsTab?.privateSectorMonitoringTab?.privateSectorMonitoringSystems != undefined && reportState.countriesPrivateSectorSuccessFactorsTab?.privateSectorMonitoringTab?.privateSectorMonitoringSystems?.length > 0) {
          reportState.countriesPrivateSectorSuccessFactorsTab!.privateSectorMonitoringTab.deleteObjetIds = monitoringSystems ? monitoringSystems?.map((p: IPrivateSectorSuccessFactorsMonitoringSystem) => { return p.OBJECTID; }) : [];
        }
      }
    }

    validateSuccessFactorsData(reportState.privateSectorSuccessFactorsTab!);
  }

  /**
   * Fill succes factors data
   * @param report
   * @param rbFeatures
   */
  const fillResultsAndBenefits = (rbFeatures: IFeature[] = [], rbJobs: any = {}) => {
    const reportState: IEditReportState = { ...state };

    const emptyRecord: IPrivateSectorResultsAndBenefitsItem = {
      isActive: true,
      isOK: false,
      OBJECTID: -1,
      report_id: '',
      name0: '',
      gid0: '',
      name1: '',
      gid1: '',
      name2: '',
      gid2: '',

      privateSectorAreaOfLandTab: {
        isOK: false,
        ha_intervention_types: '',
        ha_under_resto: 0,
        ha_imp_year: 0,
        ha_tier: '',
        ha_links: '',
        ha_information: '',
        ha_restoration_data: '',
        relevant_geospatial_data: '',
        area_restoration_system: '',
        ha_resto_intervention_link: ''
      },


      privateSectorClimateImpactsTab: {
        isOK: false,
        co2_sequestered: 0,
        co2_systems: '',
        co2_tier: '',
        co2_other: '',
        co2_contribution: 0,
        co2_links: '',
        co2_information: '',
        restoration_interventions_aim: '',
        co2_restoration_interventions: '',
        co2_other_tool: '',
        co2_certification: '',
      },

      privateSectorBiodiversityImpactsTab: {
        isOK: false,
        bio_ha_threat_species: 0,
        bio_protarea_ha: 0,
        bio_nativearea_ha: 0,
        bio_primarea_ha: 0,
        bio_intactarea_ha: 0,
        bio_redlist: '',
        bio_links: '',
        bio_information: ''
      },
      privateSectorSocioEconomicImpactsTab: {
        isOK: true,
        job_type: '1',
        psSeasonalCasualOccasional: { OBJECTID: -1, eco_type: ConfigService.getConfig().agol.operationalLayers.reportRbJobs.seasonalCasualOccasionalType },
        psLongTerm: { OBJECTID: -1, eco_type: ConfigService.getConfig().agol.operationalLayers.reportRbJobs.longTermType }
      },
      sectorReportCountries: []
    };

    if (rbFeatures && rbFeatures.length) {
      let resultsAndBenefits: IPrivateSectorResultsAndBenefitsItem[] = geResultsAndBenefits(rbFeatures, rbJobs);
      resultsAndBenefits?.map((resBen: IPrivateSectorResultsAndBenefitsItem) => {
        if (resBen.gid0 == null || resBen.gid0 == '') {
          reportState.privateSectorResultsAndBenefitsTab!.privateSectorResultsAndBenefitsItems?.push(resBen);
          reportState.privateSectorResultsAndBenefitsTab!.isGlobalMode = true;
          validateResultsAndBenefitsTab(reportState.privateSectorResultsAndBenefitsTab!);
        }
        else {
          reportState.countriesPrivateSectorResultsAndBenefitsTab!.countryprivateSectorResultsAndBenefitsItems?.push(resBen);
        }
      })
      if (reportState.privateSectorResultsAndBenefitsTab!.privateSectorResultsAndBenefitsItems!.length > 1) {
        reportState.privateSectorResultsAndBenefitsTab!.privateSectorResultsAndBenefitsItems![0].isActive = false;
        let len = reportState.privateSectorResultsAndBenefitsTab!.privateSectorResultsAndBenefitsItems!.length;
        len = len - 1;
        reportState.privateSectorResultsAndBenefitsTab!.privateSectorResultsAndBenefitsItems![len].isActive = true;
      }
      else {
        if (reportState.privateSectorResultsAndBenefitsTab!.privateSectorResultsAndBenefitsItems!.length > 0) {
          reportState.privateSectorResultsAndBenefitsTab!.privateSectorResultsAndBenefitsItems![0].isActive = true;
        }
        else {
          reportState.privateSectorResultsAndBenefitsTab?.privateSectorResultsAndBenefitsItems?.push(emptyRecord);
        }
      }
    }
    else {
      reportState.privateSectorResultsAndBenefitsTab?.privateSectorResultsAndBenefitsItems?.push(emptyRecord);
    }
  }

  /**
   * Fill succes factors data
   * @param report
   * @param rbFeatures
   */
  // const fillSplitValues = (rbFeatures: IFeature[] = [], rbValues: any = {}) => {
  //   const reportState: IEditReportState = { ...state };

  //   if (rbValues && rbValues.length) {
  //     const countrylist =rbValues?.map((p: any) => { return p.country_id; });
  //     if(countrylist ==undefined || countrylist ==null)
  //     {
  //       const split: IPrivateSectorSplitUpValues[] = getSplitData(rbFeatures, rbValues);
  //       reportState.privateSectorResultsAndBenefitsTab!.interventionSplitUp.privateSectorSplitUpValues = split;
  //     reportState.privateSectorResultsAndBenefitsTab!.interventionSplitUp.deleteRbHaRestoSplitObjetIds = split ? split?.map((p: IPrivateSectorSplitUpValues) => { return p.OBJECTID; }) : [];
  //     }

  //   }
  //   else {
  //     const emptyRow: IPrivateSectorSplitUpValues = {
  //       isOK: false,
  //       isActive: true,
  //       OBJECTID: -1,
  //       resto_split_id: '',
  //       report_rb_id: '',
  //       ecosystem_id: '',
  //       intervention_type_id: '',
  //       splitup_value: '',
  //       country_id: '',
  //       country_name: ''
  //     }
  //     reportState.privateSectorResultsAndBenefitsTab!.interventionSplitUp.privateSectorSplitUpValues?.push(emptyRow);
  //   }
  // }

  const fillSplitValues = (rbFeatures: IFeature[] = [], rbValues: any = {}) => {
    const reportState: IEditReportState = { ...state };
    const emptyRow: IPrivateSectorSplitUpValues = {
      isOK: false,
      isActive: true,
      OBJECTID: -1,
      resto_split_id: '',
      report_rb_id: '',
      ecosystem_id: '',
      intervention_type_id: '',
      splitup_value: '',
      country_id: '',
      country_name: ''
    }
    if (rbValues && rbValues.length) {
      const split: IPrivateSectorSplitUpValues[] = getSplitData(rbFeatures, rbValues);
      split?.map((splitData: IPrivateSectorSplitUpValues) => {
        if (splitData.country_id !== '') {
          reportState.countriesPrivateSectorResultsAndBenefitsTab!.countryInterventionSplitUp.countryPrivateSectorSplitUpValues?.push(splitData);
          reportState.countriesPrivateSectorResultsAndBenefitsTab!.countryInterventionSplitUp.deleteRbHaRestoSplitObjetIds = split ? split?.map((p: IPrivateSectorSplitUpValues) => { return p.OBJECTID; }) : [];
        }
        else {
          reportState.privateSectorResultsAndBenefitsTab!.interventionSplitUp!.privateSectorSplitUpValues?.push(splitData);
          reportState.privateSectorResultsAndBenefitsTab!.interventionSplitUp!.deleteRbHaRestoSplitObjetIds = split ? split?.map((p: IPrivateSectorSplitUpValues) => { return p.OBJECTID; }) : [];
        }
      });
    }
    if (reportState.privateSectorResultsAndBenefitsTab!.interventionSplitUp!.privateSectorSplitUpValues == undefined || reportState.privateSectorResultsAndBenefitsTab!.interventionSplitUp!.privateSectorSplitUpValues.length < 1) {
      reportState.privateSectorResultsAndBenefitsTab!.interventionSplitUp!.privateSectorSplitUpValues?.push(emptyRow);
    }
    if (reportState.countriesPrivateSectorResultsAndBenefitsTab!.countryInterventionSplitUp!.countryPrivateSectorSplitUpValues == undefined
      || reportState.countriesPrivateSectorResultsAndBenefitsTab!.countryInterventionSplitUp!.countryPrivateSectorSplitUpValues.length < 1) {
      const emptyCountryRow: ICountriesPrivateSectorSplitUpValues = {
        isOK: false,
        isActive: true,
        OBJECTID: -1,
        resto_split_id: '0',
        report_rb_id: '',
        ecosystem_id: '',
        intervention_type_id: '',
        splitup_value: '',
        country_id: '',
        country_name: ''
      }
      reportState.countriesPrivateSectorResultsAndBenefitsTab!.countryInterventionSplitUp.countryPrivateSectorSplitUpValues?.push(emptyCountryRow);
    }

  }

  const fillCountriesIndicators = (rbFeatures: IFeature[] = [], reportCountriesIndicatorsFeatures: any = {}) => {
    const reportState: IEditReportState = { ...state };

    if (rbFeatures && rbFeatures.length) {
      const split: IReportCountriesIndicators[] = getSuccessCountriesIndicators(rbFeatures, reportCountriesIndicatorsFeatures);
      reportState.restorationPledgeTrackingDetailsTab!.sectorReportCountries.privateSectorReportCountriesIndicators! = split;
      reportState.restorationPledgeTrackingDetailsTab!.sectorReportCountries.deleteCountriesIndicatorObjetIds = split ? split?.map((p: IReportCountriesIndicators) => { return p.OBJECTID; }) : [];
    }
    else {
      const emptyRow: IReportCountriesIndicators = {
        isActive: true,
        isOK: false,
        OBJECTID: -1,
        report_id: '',
        country_indicator: '',
        country_id: '',
        action_indicator: '',
        impact_indicator: '5'
      }
      reportState.restorationPledgeTrackingDetailsTab!.sectorReportCountries.privateSectorReportCountriesIndicators?.push(emptyRow);
    }
  }


  /**
   * Select tab
   */
  const selectTab = (index: number) => {
    const obj: IEditReportState = { ...state };

    obj.generalInfoTab!.isActive = index === 0;
    obj.restorationPledgeTrackingTab!.isActive = index === 1;
    obj.restorationPledgeTrackingDetailsTab!.isActive = index === 2;
    obj.privateSectorSuccessFactorsTab!.isActive = index === 3;
    obj.privateSectorResultsAndBenefitsTab!.isActive = index === 4;

    setState(obj);
  };

  /**
   * Handle save draft hover
   */
  const draftMouseOver = (hovered: boolean) => {
    const obj: any = { ...localState };
    obj.drafBtnMouseOver = hovered;
    setLocalState(obj);
  }

  /**
   * Handle submit hover
   */
  /*const submittMouseOver = (hovered: boolean) => {
   const obj: any = { ...localState };
   obj.submitBtnMouseOver = hovered;
   setLocalState(obj);
 }*/


  /**
   * Validate generalInfo data
   * @param generalInfoTab 
  */
  const validateGeneralInfoData = (generalInfoTab: IGeneralInformationTab | undefined): void => {
    // Check mandatory fields
    let isOK = generalInfoTab ? Utils.checkRequiredFields(ConfigService.getConfig().agol.operationalLayers.reportMain.psRequiredFields.generalInfo, generalInfoTab) : false;

    // Check mail format
    const email: string | undefined = generalInfoTab?.email;

    if (email) {
      const isMailOK: boolean = Utils.validateMail(email);
      isOK = isOK && isMailOK;
      generalInfoTab!.emailOK = isMailOK;
    }

    generalInfoTab!.isOK = isOK;
  }


  /**
   * Validate restoration pledge tracking summary
   * @param restorationPledgeTrackingTab 
   */
  const validateRestorationPledgeTrackingData = (restorationPledgeTrackingTab: IRestorationPledgeTrackingTab | undefined): void => {
    // Check mandatory fields
    restorationPledgeTrackingTab!.isOK = restorationPledgeTrackingTab ? Utils.checkRequiredFields(ConfigService.getConfig().agol.operationalLayers.reportMain.psRequiredFields.restorationPledgeTracking, restorationPledgeTrackingTab) : false;
  }

  /**
   * Validate restoration pledge tracking detail
   * @param restorationPledgeTrackingTab 
   */
  const validateRestorationPledgeTrackingDetailData = (restorationPledgeTrackingDetailsTab: IRestorationPledgeTrackingDetailsTab | undefined): void => {
    // Check mandatory fields
    restorationPledgeTrackingDetailsTab!.isOK = restorationPledgeTrackingDetailsTab ? Utils.checkRequiredFields(ConfigService.getConfig().agol.operationalLayers.reportMain.psRequiredFields.restorationPledgeTrackingDetails, restorationPledgeTrackingDetailsTab) : false;
    restorationPledgeTrackingDetailsTab!.isOK = validateThreeIndicatorsSelected();
  }


  /**
   * Validate success factors data
   * @param privateSectorSuccessFactorsTab 
   * @param metadataModalityTab 
   */
  const validateSuccessFactorsData = (privateSectorSuccessFactorsTab: IPrivateSectorSuccessFactorsTab): void => {
    let isOK = true;

    if (privateSectorSuccessFactorsTab) {

      // 1) Report policies
      if (privateSectorSuccessFactorsTab.policiesAndStrategiesTab.policiesAndStrategies.length) {
        privateSectorSuccessFactorsTab.policiesAndStrategiesTab.policiesAndStrategies.forEach((i: ISuccessFactorsPolicyStrategies) => {
          isOK = isOK && Utils.checkRequiredFields(ConfigService.getConfig().agol.operationalLayers.reportPolicies.sectorRequiredFields, i);

          if (!isOK) {
            return false;
          }
        });
      }


      // 2) Report financial flows
      if (isOK && privateSectorSuccessFactorsTab.privateSectorFinancialFlowsTab) {
        if (isOK) {
          isOK = isOK && Utils.checkRequiredFields(ConfigService.getConfig().agol.operationalLayers.reportFinancialFlows.psRequiredFields, privateSectorSuccessFactorsTab.privateSectorFinancialFlowsTab.totalDomesticPublicExpenditure);
        }

        // if (isOK) {
        //   isOK = isOK && Utils.checkRequiredFields(ConfigService.getConfig().agol.operationalLayers.reportFinancialFlows.requiredFields, privateSectorSuccessFactorsTab.privateSectorFinancialFlowsTab.totalPrivateInvestments);
        // }

        // if (isOK) {
        //   isOK = isOK && Utils.checkRequiredFields(ConfigService.getConfig().agol.operationalLayers.reportFinancialFlows.requiredFields, privateSectorSuccessFactorsTab.privateSectorFinancialFlowsTab.totalInternationalDonorSupport);
        // }

        // if (isOK) {
        //   isOK = isOK && Utils.checkRequiredFields(ConfigService.getConfig().agol.operationalLayers.reportFinancialFlows.requiredFields, privateSectorSuccessFactorsTab.privateSectorFinancialFlowsTab.totalDomesticPhilanthropicAndNonProfit);
        // }
      }

      // 3) Report technical planning
      if (isOK && privateSectorSuccessFactorsTab.privateSectorTechnicalPlanningTab.privateSectorPlanningMethodologies.length) {
        privateSectorSuccessFactorsTab.privateSectorTechnicalPlanningTab.privateSectorPlanningMethodologies.forEach((i: IPrivateSectorSuccessFactorsPlanningMethodology) => {
          isOK = isOK && Utils.checkRequiredFields(ConfigService.getConfig().agol.operationalLayers.reportTechnicalPlanning.psRequiredFields, i);

          if (!isOK) {
            return false;
          }
        });
      }

      // 4) Report monitoring
      if (isOK && privateSectorSuccessFactorsTab.privateSectorMonitoringTab.privateSectorMonitoringSystems.length) {
        privateSectorSuccessFactorsTab.privateSectorMonitoringTab.privateSectorMonitoringSystems.forEach((i: IPrivateSectorSuccessFactorsMonitoringSystem) => {
          isOK = isOK && Utils.checkRequiredFields(ConfigService.getConfig().agol.operationalLayers.reportMonitoring.psRequiredFields, i);

          if (!isOK) {
            return false;
          }
        });
      }
    }

    privateSectorSuccessFactorsTab!.isOK = isOK;
  }

  /**
   * Validate results and benefits tab
   * @param item 
   * @returns 
   */
  const validateResultsAndBenefitsTab = (rb: IPrivateSectorResultsAndBenefitsTab): void => {
    let isOK = true;

    if (rb.privateSectorResultsAndBenefitsItems && rb.privateSectorResultsAndBenefitsItems.length) {
      rb.privateSectorResultsAndBenefitsItems.forEach((item: IPrivateSectorResultsAndBenefitsItem) => {
        item.privateSectorAreaOfLandTab.isOK = Utils.checkRequiredFields(ConfigService.getConfig().agol.operationalLayers.reportRb.psRequiredFields.psAreaOfLand, item.privateSectorAreaOfLandTab);
        item.privateSectorClimateImpactsTab.isOK = Utils.checkRequiredFields(ConfigService.getConfig().agol.operationalLayers.reportRb.psRequiredFields.psClimateImpacts, item.privateSectorClimateImpactsTab);
        item.privateSectorBiodiversityImpactsTab.isOK = Utils.checkRequiredFields(ConfigService.getConfig().agol.operationalLayers.reportRb.psRequiredFields.psBiodiversityImpacts, item.privateSectorBiodiversityImpactsTab);
        item.privateSectorSocioEconomicImpactsTab!.isOK = (Utils.checkRequiredFields(ConfigService.getConfig().agol.operationalLayers.reportRbJobs.psRequiredFields, item.privateSectorSocioEconomicImpactsTab?.psSeasonalCasualOccasional) &&
          //Utils.checkRequiredFields(ConfigService.getConfig().agol.operationalLayers.reportRbJobs.requiredFields, item.privateSectorSocioEconomicImpactsTab?.shortTerm) &&
          Utils.checkRequiredFields(ConfigService.getConfig().agol.operationalLayers.reportRbJobs.psRequiredFields, item.privateSectorSocioEconomicImpactsTab?.psLongTerm)); //&&
        //Utils.checkRequiredFields(ConfigService.getConfig().agol.operationalLayers.reportRbJobs.requiredFields, item.privateSectorSocioEconomicImpactsTab?.unspecified));

        item.isOK = (item.privateSectorAreaOfLandTab.isOK && item.privateSectorClimateImpactsTab.isOK && item.privateSectorBiodiversityImpactsTab.isOK && item.privateSectorSocioEconomicImpactsTab?.isOK) || false;
        // if (item.privateSectorAreaOfLandTab != undefined) 
        // {
        //   if(state.privateSectorResultsAndBenefitsTab!.privateSectorResultsAndBenefitsItems!.length > 0)
        //   {
        //     state.privateSectorResultsAndBenefitsTab!.privateSectorResultsAndBenefitsItems![0].privateSectorAreaOfLandTab!.isOK = item.privateSectorAreaOfLandTab.isOK;
        //   }

        //   if(state.privateSectorResultsAndBenefitsTab!.interventionSplitUp!.privateSectorSplitUpValues.length > 0)
        //   {
        //     state.privateSectorResultsAndBenefitsTab!.interventionSplitUp!.privateSectorSplitUpValues[0]!.isOK = validateSplitValues(rb);
        //   }          
        // }

        if (!item.isOK) {
          isOK = false;
        }
      });
    } else {
      isOK = false;
    }

    rb.isOK = isOK;
  }


  /**
   * Get General Information attributes
   * @returns
   */
  const getGeneralInfoAtts = (): any => {
    const atts: any = {};

    if (state) {
      const tab: IGeneralInformationTab | undefined = state.generalInfoTab;

      if (tab) {
        atts[ConfigService.getConfig().agol.operationalLayers.reportMain.fields.objectid] = reportId;
        atts.company_name = tab.company_name;
        atts.country_headquarter = tab.country_headquarter;
        atts.focal_point_name = tab.focal_point_name;
        atts.company_focal_point_position = tab.company_focal_point_position;
        atts.email = tab.email;
        atts.ps_report_type = tab.ps_report_type;
        atts.link_website = tab.link_website == null ? '' : Utils.saveLinkFormat(tab.link_website);
      }
    }

    return atts;
  }

  /**
   * Get RestorationPledgeTracking attributes
   * @returns
   */
  const getRestorationPledgeTrackingAtts = (): any => {
    const atts: any = {};

    if (state) {
      const tab: IRestorationPledgeTrackingTab | undefined = state.restorationPledgeTrackingTab;

      if (tab) {
        atts[ConfigService.getConfig().agol.operationalLayers.reportMain.fields.objectid] = reportId;
        if (tab.pledge_start_date) {
          atts.pledge_start = new Date(tab.pledge_start_date).getFullYear();
        }
        atts.pledge_start_date = tab.pledge_start_date;
        atts.pledge_end = tab.pledge_end;
        atts.linked_init = tab.linked_init;
        atts.linked_init_other = tab.linked_init_other;
        atts.links = Utils.saveLinkFormat(tab.links);
        atts.current_pledge = tab.current_pledge;
        atts.ecosystems = tab.ecosystems;
        atts.ecosystems_other = tab.ecosystems_other;
        atts.pledge_implementation = tab.pledge_implementation;
        if (tab.pledge_implementation?.indexOf('999') !== -1) {
          atts.pledge_implementation_other = tab.pledge_implementation_other;
        }
        else {
          atts.pledge_implementation_other = '';
        }
        if (tab.pledge_implementation?.indexOf('2') !== -1) {
          atts.pledge_impl_financial_support = tab.pledge_impl_financial_support;
        }
        else {
          atts.pledge_impl_financial_support = '';
        }
        atts.achievements_learnings = tab.achievements_learnings;
        atts.pledge_fulfil = tab.pledge_fulfil;
        atts.is_previously_reported = tab.is_previously_reported;
      }
    }

    return atts;
  }

  /**
   * validateThreeIndicatorsSelected
   * @returns
   */
  const validateThreeIndicatorsSelected = (): any => {
    let isValid: boolean = true;
    const tab: IRestorationPledgeTrackingDetailsTab | undefined = state.restorationPledgeTrackingDetailsTab;
    if (tab) {
      if (tab.location_specific != null && tab.location_specific === "1") {
        tab!.sectorReportCountries.privateSectorReportCountriesIndicators!.forEach((item: any) => {
          if (isValid) {
            if (item.impact_indicator?.indexOf('5') === -1) {
              tab.isOK = false;
              isValid = false;
              return;
            }
            else {
              let actionCount = 0;
              let impCount = 0;
              let selIndictor = 0;
              if (item.action_indicator != null && item.action_indicator?.indexOf(",") !== -1) {
                actionCount = item.action_indicator!.split(",").length;
              }
              if (item.action_indicator != null && item.action_indicator?.indexOf(",") === -1) {
                actionCount = item.action_indicator.length;
              }
              if (item.impact_indicator != null && item.impact_indicator?.indexOf(",") !== -1) {
                impCount = item.impact_indicator!.split(",").length;
              }
              if (item.impact_indicator != null && item.impact_indicator?.indexOf(",") === -1) {
                impCount = item.impact_indicator.length;
              }
              selIndictor = actionCount + impCount;
              if (selIndictor < 3) {
                tab.isOK = false;
                isValid = false;
                return;
              }
            }
          }
        })
      }
      else {
        if (tab.impact_indicators?.indexOf('5') === -1) {
          tab.isOK = false;
          isValid = false;
          return;
        }
        else {
          let actionCount = 0;
          let impCount = 0;
          let selIndictor = 0;
          if (tab.action_indicators != null && tab.action_indicators?.indexOf(",") !== -1) {
            actionCount = tab.action_indicators!.split(",").length;
          }
          if (tab.action_indicators != null && tab.action_indicators?.indexOf(",") === -1) {
            actionCount = tab.action_indicators.length;
          }
          if (tab.impact_indicators != null && tab.impact_indicators?.indexOf(",") !== -1) {
            impCount = tab.impact_indicators!.split(",").length;
          }
          if (tab.impact_indicators != null && tab.impact_indicators?.indexOf(",") === -1) {
            impCount = tab.impact_indicators!.length;
          }
          selIndictor = actionCount + impCount;
          if (selIndictor < 3) {
            tab.isOK = false;
            isValid = false;
            return;
          }
        }

      }
    }
    return isValid;
  }
  const getRestorationPledgeTrackingDetailsAtts = (): any => {
    const atts: any = {};

    if (state) {
      const tab: IRestorationPledgeTrackingDetailsTab | undefined = state.restorationPledgeTrackingDetailsTab;

      if (tab) {

        atts[ConfigService.getConfig().agol.operationalLayers.reportMain.fields.objectid] = reportId;
        atts.location_specific = tab.location_specific;
        atts.action_indicators = tab.action_indicators;
        atts.impact_indicators = tab.impact_indicators;
      }
    }

    return atts;
  }

  /**
   * Get success factors policies
   * @returns
   */
  const getPrivateSectorSuccessFactorsPoliciesAtts = (): { adds: ISuccessFactorsPolicyStrategies[], updates: ISuccessFactorsPolicyStrategies[] } => {
    let policiesAndStrategies: { adds: ISuccessFactorsPolicyStrategies[], updates: ISuccessFactorsPolicyStrategies[] } = { adds: [], updates: [] };

    if (state) {
      const tab: IPrivateSectorSuccessFactorsTab | undefined = state.privateSectorSuccessFactorsTab;
      const tab2: ICountriesPrivateSectorSuccessFactorsTab | undefined = state.countriesPrivateSectorSuccessFactorsTab;

      if (tab && tab.policiesAndStrategiesTab.policiesAndStrategies) {
        tab.policiesAndStrategiesTab.policiesAndStrategies.forEach((i: ISuccessFactorsPolicyStrategies) => {
          i.information = Utils.saveLinkFormat(i.information);
          i.responsible = Utils.saveLinkFormat(i.responsible);
          i.links = Utils.saveLinkFormat(i.links);
          policiesAndStrategies.adds.push(i);
        });
      }
      if (tab2 && tab2.policiesAndStrategiesTab.policiesAndStrategies && tab2.policiesAndStrategiesTab.policiesAndStrategies.length > 0) {
        let reportId = localState.rb_MainGlobalId;
        let countryData = state.restorationPledgeTrackingDetailsTab?.sectorReportCountries.privateSectorReportCountriesIndicators.filter((x: IReportCountriesIndicators) => x.report_id == reportId);
        countryData?.forEach((county: IReportCountriesIndicators) => {
          tab2.policiesAndStrategiesTab.policiesAndStrategies.forEach((i: ISuccessFactorsPolicyStrategies) => {
            if (county.country_id == i.country_id) {
              i.information = Utils.saveLinkFormat(i.information);
              i.responsible = Utils.saveLinkFormat(i.responsible);
              i.links = Utils.saveLinkFormat(i.links);
              policiesAndStrategies.adds.push(i);
            }
          });
        })
      }
    }
    return policiesAndStrategies;
  }

  /**
   * Get success factors policies
   * @returns
   */
  const getSuccessFactorsFinancialFlowsAtts = (): { adds: IPrivateSectorSuccessFactorsFinancialFlow[], updates: IPrivateSectorSuccessFactorsFinancialFlow[] } => {
    let financialFlows: { adds: IPrivateSectorSuccessFactorsFinancialFlow[], updates: IPrivateSectorSuccessFactorsFinancialFlow[] } = { adds: [], updates: [] };

    if (state) {
      const tab: IPrivateSectorSuccessFactorsTab | undefined = state.privateSectorSuccessFactorsTab;
      const tab2: ICountriesPrivateSectorSuccessFactorsTab | undefined = state.countriesPrivateSectorSuccessFactorsTab;

      if (tab && tab.privateSectorFinancialFlowsTab) {
        // 1) totalDomesticPublicExpenditure
        if (tab.privateSectorFinancialFlowsTab.totalDomesticPublicExpenditure && tab.privateSectorFinancialFlowsTab.totalDomesticPublicExpenditure.type != null) {
          tab.privateSectorFinancialFlowsTab.totalDomesticPublicExpenditure.tier = tab.privateSectorFinancialFlowsTab.totalDomesticPublicExpenditure.tier !== '-999' ? tab.privateSectorFinancialFlowsTab.totalDomesticPublicExpenditure.tier : '';
          tab.privateSectorFinancialFlowsTab.totalDomesticPublicExpenditure.OBJECTID = -1;
          tab.privateSectorFinancialFlowsTab.totalDomesticPublicExpenditure.report_id = localState.rb_MainGlobalId;
          tab.privateSectorFinancialFlowsTab.totalDomesticPublicExpenditure.financial_support_contribute = Utils.saveLinkFormat(tab.privateSectorFinancialFlowsTab.totalDomesticPublicExpenditure.financial_support_contribute);
          tab.privateSectorFinancialFlowsTab.totalDomesticPublicExpenditure.sources = Utils.saveLinkFormat(tab.privateSectorFinancialFlowsTab.totalDomesticPublicExpenditure.sources);
          financialFlows.adds.push(tab.privateSectorFinancialFlowsTab.totalDomesticPublicExpenditure);
        }
      }
      if (tab2 && tab2.privateSectorFinancialFlowsTab && tab2.privateSectorFinancialFlowsTab.totalDomesticPublicExpenditure!.length > 0) {
        let reportId = localState.rb_MainGlobalId;
        let countryData = state.restorationPledgeTrackingDetailsTab?.sectorReportCountries.privateSectorReportCountriesIndicators.filter((x: IReportCountriesIndicators) => x.report_id == reportId);
        countryData?.forEach((county: IReportCountriesIndicators) => {
          // 1) totalDomesticPublicExpenditure
          tab2.privateSectorFinancialFlowsTab.totalDomesticPublicExpenditure!.forEach((i: IPrivateSectorSuccessFactorsFinancialFlow) => {
            if (county.country_id == i.country_id) {
              i.type = '1';
              i.tier = i.tier !== '-999' ? i.tier : '';
              i.OBJECTID = -1;
              i.financial_support_contribute = Utils.saveLinkFormat(i.financial_support_contribute);
              i.sources = Utils.saveLinkFormat(i.sources);
              financialFlows.adds.push(i);
            }
          });
        })
      }
    }

    return financialFlows;
  }


  /**
   * Get success factors planning methodologies
   * @returns
   */
  const getSuccessFactorsPlanningMethodologiesAtts = (): { adds: IPrivateSectorSuccessFactorsPlanningMethodology[], updates: IPrivateSectorSuccessFactorsPlanningMethodology[] } => {
    const methodologies: { adds: IPrivateSectorSuccessFactorsPlanningMethodology[], updates: IPrivateSectorSuccessFactorsPlanningMethodology[] } = { adds: [], updates: [] };

    if (state) {
      const tab: IPrivateSectorSuccessFactorsTab | undefined = state.privateSectorSuccessFactorsTab;
      const tab2: ICountriesPrivateSectorSuccessFactorsTab | undefined = state.countriesPrivateSectorSuccessFactorsTab;

      if (tab && tab.privateSectorTechnicalPlanningTab.privateSectorPlanningMethodologies) {
        tab.privateSectorTechnicalPlanningTab.privateSectorPlanningMethodologies.forEach((i: IPrivateSectorSuccessFactorsPlanningMethodology) => {

          i.OBJECTID = -1;
          i.report_id = localState.rb_MainGlobalId;
          i.links = Utils.saveLinkFormat(i.links);
          i.methodology = Utils.saveLinkFormat(i.methodology);
          i.explanation = Utils.saveLinkFormat(i.explanation);
          methodologies.adds.push(i);
        });
      }
      if (tab2 && tab2.privateSectorTechnicalPlanningTab.privateSectorPlanningMethodologies && tab2.privateSectorTechnicalPlanningTab.privateSectorPlanningMethodologies.length > 0) {
        let reportId = localState.rb_MainGlobalId;
        let countryData = state.restorationPledgeTrackingDetailsTab?.sectorReportCountries.privateSectorReportCountriesIndicators.filter((x: IReportCountriesIndicators) => x.report_id == reportId);
        countryData?.forEach((county: IReportCountriesIndicators) => {
          tab2.privateSectorTechnicalPlanningTab.privateSectorPlanningMethodologies.forEach((i: IPrivateSectorSuccessFactorsPlanningMethodology) => {
            if (county.country_id == i.country_id) {
              i.OBJECTID = -1;
              i.report_id = localState.rb_MainGlobalId;
              i.links = Utils.saveLinkFormat(i.links);
              i.methodology = Utils.saveLinkFormat(i.methodology);
              i.explanation = Utils.saveLinkFormat(i.explanation);
              methodologies.adds.push(i);
            }
          });
        })
      }
    }

    return methodologies;
  }


  /**
   * Get success factors monitoring systems
   * @returns
   */
  const getSuccessFactorsMonitoringSystemsAtts = (): { adds: IPrivateSectorSuccessFactorsMonitoringSystem[], updates: IPrivateSectorSuccessFactorsMonitoringSystem[] } => {
    const systems: { adds: IPrivateSectorSuccessFactorsMonitoringSystem[], updates: IPrivateSectorSuccessFactorsMonitoringSystem[] } = { adds: [], updates: [] };

    if (state) {
      const tab: IPrivateSectorSuccessFactorsTab | undefined = state.privateSectorSuccessFactorsTab;
      const tab2: ICountriesPrivateSectorSuccessFactorsTab | undefined = state.countriesPrivateSectorSuccessFactorsTab;

      if (tab && tab.privateSectorMonitoringTab.privateSectorMonitoringSystems) {
        tab.privateSectorMonitoringTab.privateSectorMonitoringSystems.forEach((i: IPrivateSectorSuccessFactorsMonitoringSystem) => {

          i.OBJECTID = -1;
          i.report_id = localState.rb_MainGlobalId;
          i.monitoring_system = Utils.saveLinkFormat(i.monitoring_system);
          i.information = Utils.saveLinkFormat(i.information);
          i.links = Utils.saveLinkFormat(i.links);
          systems.adds.push(i);
        });
      }

      if (tab2 && tab2.privateSectorMonitoringTab.privateSectorMonitoringSystems && tab2.privateSectorMonitoringTab.privateSectorMonitoringSystems.length > 0) {
        let reportId = localState.rb_MainGlobalId;
        let countryData = state.restorationPledgeTrackingDetailsTab?.sectorReportCountries.privateSectorReportCountriesIndicators.filter((x: IReportCountriesIndicators) => x.report_id == reportId);
        countryData?.forEach((county: IReportCountriesIndicators) => {
          tab2.privateSectorMonitoringTab.privateSectorMonitoringSystems.forEach((i: IPrivateSectorSuccessFactorsMonitoringSystem) => {
            if (county.country_id == i.country_id) {
              i.OBJECTID = -1;
              i.report_id = localState.rb_MainGlobalId;
              i.monitoring_system = Utils.saveLinkFormat(i.monitoring_system);
              i.information = Utils.saveLinkFormat(i.information);
              i.links = Utils.saveLinkFormat(i.links);
              systems.adds.push(i);
            }
          });
        })
      }
    }

    return systems;
  }


  // const getResultsAndBenefitsAtts = (): { adds: IPrivateSectorResultsAndBenefitsItem[], updates: IPrivateSectorResultsAndBenefitsItem[] } => {
  //   const rbList: { adds: IPrivateSectorResultsAndBenefitsItem[], updates: IPrivateSectorResultsAndBenefitsItem[] } = { adds: [], updates: [] };

  //   if (state) {
  //     const tab: IPrivateSectorResultsAndBenefitsTab | undefined = state.privateSectorResultsAndBenefitsTab;
  //     const tab2: ICountriesPrivateSectorResultsAndBenefitsTab | undefined = state.countriesPrivateSectorResultsAndBenefitsTab;

  //     if (tab && tab.privateSectorResultsAndBenefitsItems && tab.isGlobalMode) {
  //       tab.privateSectorResultsAndBenefitsItems.forEach((i: IPrivateSectorResultsAndBenefitsItem) => {          
  //         i.OBJECTID = -1;
  //         i.report_id = localState.rb_MainGlobalId;
  //         if (i.privateSectorAreaOfLandTab.ha_restoration_data == "0") {
  //           i.privateSectorAreaOfLandTab.ha_under_resto = 0;
  //           i.privateSectorAreaOfLandTab.ha_tier = '';
  //         }
  //         if (i.privateSectorAreaOfLandTab.ha_restoration_data == "1") {
  //           i.privateSectorAreaOfLandTab.area_restoration_system = "";
  //         }
  //         i.privateSectorAreaOfLandTab.ha_tier = i.privateSectorAreaOfLandTab.ha_tier !== '-999' ? i.privateSectorAreaOfLandTab.ha_tier : '';
  //         i.privateSectorAreaOfLandTab.area_restoration_system = Utils.saveLinkFormat(i.privateSectorAreaOfLandTab.area_restoration_system);
  //         i.privateSectorAreaOfLandTab.ha_information = Utils.saveLinkFormat(i.privateSectorAreaOfLandTab.ha_information);
  //         i.privateSectorAreaOfLandTab.ha_links = Utils.saveLinkFormat(i.privateSectorAreaOfLandTab.ha_links);
  //         i.privateSectorClimateImpactsTab.co2_tier = i.privateSectorClimateImpactsTab.co2_tier !== '-999' ? i.privateSectorClimateImpactsTab.co2_tier : '';
  //         i.privateSectorClimateImpactsTab.co2_information = Utils.saveLinkFormat(i.privateSectorClimateImpactsTab.co2_information);
  //         i.privateSectorClimateImpactsTab.co2_links = Utils.saveLinkFormat(i.privateSectorClimateImpactsTab.co2_links);
  //         i.privateSectorBiodiversityImpactsTab.bio_information = i.privateSectorBiodiversityImpactsTab.bio_information?.toString();
  //         i.privateSectorBiodiversityImpactsTab.bio_redlist = Utils.saveLinkFormat(i.privateSectorBiodiversityImpactsTab.bio_redlist);
  //         i.privateSectorBiodiversityImpactsTab.bio_links = Utils.saveLinkFormat(i.privateSectorBiodiversityImpactsTab.bio_links);

  //         // Sum of jobs created
  //         let jobsCreated = 0;
  //         jobsCreated += i.privateSectorSocioEconomicImpactsTab && i.privateSectorSocioEconomicImpactsTab.psSeasonalCasualOccasional && i.privateSectorSocioEconomicImpactsTab.psSeasonalCasualOccasional.eco_jobs ? Number(i.privateSectorSocioEconomicImpactsTab.psSeasonalCasualOccasional.eco_jobs) : 0;
  //         jobsCreated += i.privateSectorSocioEconomicImpactsTab && i.privateSectorSocioEconomicImpactsTab.psLongTerm && i.privateSectorSocioEconomicImpactsTab.psLongTerm.eco_jobs ? Number(i.privateSectorSocioEconomicImpactsTab.psLongTerm.eco_jobs) : 0;

  //         rbList.adds.push(i);

  //         // return {
  //         //   ...{ OBJECTID: i.OBJECTID, report_id: i.report_id, GID_0: i.gid1, NAME_0: i.name1, eco_jobs_created: jobsCreated },
  //         //   ...i.privateSectorAreaOfLandTab,
  //         //   ...i.privateSectorClimateImpactsTab,
  //         //   ...i.privateSectorBiodiversityImpactsTab
  //         // };

  //       });
  //     }
  //         else {
  //        tab2!.countryprivateSectorResultsAndBenefitsItems!.map((i: ICountryPrivateSectorResultsAndBenefitsItem) => {
  //         i.OBJECTID = -1;
  //         i.report_id = localState.rb_MainGlobalId;
  //         if (i.privateSectorAreaOfLandTab.ha_restoration_data == "0") {
  //           i.privateSectorAreaOfLandTab.ha_under_resto = 0;
  //           i.privateSectorAreaOfLandTab.ha_tier = '';
  //         }
  //         if (i.privateSectorAreaOfLandTab.ha_restoration_data == "1") {
  //           i.privateSectorAreaOfLandTab.area_restoration_system = "";
  //         }
  //         i.privateSectorAreaOfLandTab.ha_tier = i.privateSectorAreaOfLandTab.ha_tier !== '-999' ? i.privateSectorAreaOfLandTab.ha_tier : '';
  //         i.privateSectorClimateImpactsTab.co2_tier = i.privateSectorClimateImpactsTab.co2_tier !== '-999' ? i.privateSectorClimateImpactsTab.co2_tier : '';
  //         i.privateSectorBiodiversityImpactsTab.bio_information = i.privateSectorBiodiversityImpactsTab.bio_information?.toString();
  //         // Sum of jobs created
  //         let jobsCreated = 0;
  //         jobsCreated += i.privateSectorSocioEconomicImpactsTab && i.privateSectorSocioEconomicImpactsTab.psSeasonalCasualOccasional && i.privateSectorSocioEconomicImpactsTab.psSeasonalCasualOccasional.eco_jobs ? Number(i.privateSectorSocioEconomicImpactsTab.psSeasonalCasualOccasional.eco_jobs) : 0;
  //        jobsCreated += i.privateSectorSocioEconomicImpactsTab && i.privateSectorSocioEconomicImpactsTab.psLongTerm && i.privateSectorSocioEconomicImpactsTab.psLongTerm.eco_jobs ? Number(i.privateSectorSocioEconomicImpactsTab.psLongTerm.eco_jobs) : 0;

  //        rbList.adds.push(i);

  //         // return {
  //         //   ...{ OBJECTID: i.OBJECTID, report_id: i.report_id, GID_0: i.gid0, NAME_0: i.name0, eco_jobs_created: jobsCreated },
  //         //   ...i.privateSectorAreaOfLandTab,
  //         //   ...i.privateSectorClimateImpactsTab,
  //         //   ...i.privateSectorBiodiversityImpactsTab
  //         // };

  //       });
  //     }
  //   }

  //   return rbList;
  // }

  /**
   * Get results and benefits atts
   * @returns
   */
  const getResultsAndBenefitsAtts = (): any[] => {
    if (state) {
      const commonPush: IPrivateSectorResultsAndBenefitsTab | undefined = state.privateSectorResultsAndBenefitsTab;
      const tab: IPrivateSectorResultsAndBenefitsTab | undefined = state.privateSectorResultsAndBenefitsTab;
      const tab2: ICountriesPrivateSectorResultsAndBenefitsTab | undefined = state.countriesPrivateSectorResultsAndBenefitsTab;

      if (tab && tab.privateSectorResultsAndBenefitsItems && tab.isGlobalMode) {
        return tab.privateSectorResultsAndBenefitsItems.map((i: IPrivateSectorResultsAndBenefitsItem) => {
          i.OBJECTID = -1;
          i.report_id = localState.rb_MainGlobalId;
          if (i.privateSectorAreaOfLandTab.ha_restoration_data == "0") {
            i.privateSectorAreaOfLandTab.ha_under_resto = 0;
            i.privateSectorAreaOfLandTab.ha_tier = '';
          }
          if (i.privateSectorAreaOfLandTab.ha_restoration_data == "1") {
            i.privateSectorAreaOfLandTab.area_restoration_system = "";
          }
          i.privateSectorAreaOfLandTab.ha_tier = i.privateSectorAreaOfLandTab.ha_tier !== '-999' ? i.privateSectorAreaOfLandTab.ha_tier : '';
          i.privateSectorAreaOfLandTab.area_restoration_system = Utils.saveLinkFormat(i.privateSectorAreaOfLandTab.area_restoration_system);
          i.privateSectorAreaOfLandTab.ha_information = Utils.saveLinkFormat(i.privateSectorAreaOfLandTab.ha_information);
          i.privateSectorAreaOfLandTab.ha_links = Utils.saveLinkFormat(i.privateSectorAreaOfLandTab.ha_links);
          i.privateSectorClimateImpactsTab.co2_tier = i.privateSectorClimateImpactsTab.co2_tier !== '-999' ? i.privateSectorClimateImpactsTab.co2_tier : '';
          i.privateSectorClimateImpactsTab.co2_information = Utils.saveLinkFormat(i.privateSectorClimateImpactsTab.co2_information);
          i.privateSectorClimateImpactsTab.co2_links = Utils.saveLinkFormat(i.privateSectorClimateImpactsTab.co2_links);
          i.privateSectorBiodiversityImpactsTab.bio_information = i.privateSectorBiodiversityImpactsTab.bio_information?.toString();
          i.privateSectorBiodiversityImpactsTab.bio_redlist = Utils.saveLinkFormat(i.privateSectorBiodiversityImpactsTab.bio_redlist);
          i.privateSectorBiodiversityImpactsTab.bio_links = Utils.saveLinkFormat(i.privateSectorBiodiversityImpactsTab.bio_links);

          // Sum of jobs created
          let jobsCreated = 0;
          jobsCreated += i.privateSectorSocioEconomicImpactsTab && i.privateSectorSocioEconomicImpactsTab.psSeasonalCasualOccasional && i.privateSectorSocioEconomicImpactsTab.psSeasonalCasualOccasional.eco_jobs ? Number(i.privateSectorSocioEconomicImpactsTab.psSeasonalCasualOccasional.eco_jobs) : 0;
          //jobsCreated += i.privateSectorSocioEconomicImpactsTab && i.privateSectorSocioEconomicImpactsTab.shortTerm && i.privateSectorSocioEconomicImpactsTab.shortTerm.eco_jobs ? Number(i.privateSectorSocioEconomicImpactsTab.shortTerm.eco_jobs) : 0;
          jobsCreated += i.privateSectorSocioEconomicImpactsTab && i.privateSectorSocioEconomicImpactsTab.psLongTerm && i.privateSectorSocioEconomicImpactsTab.psLongTerm.eco_jobs ? Number(i.privateSectorSocioEconomicImpactsTab.psLongTerm.eco_jobs) : 0;
          //jobsCreated += i.privateSectorSocioEconomicImpactsTab && i.privateSectorSocioEconomicImpactsTab.unspecified && i.privateSectorSocioEconomicImpactsTab.unspecified.eco_jobs ? Number(i.privateSectorSocioEconomicImpactsTab.unspecified.eco_jobs) : 0;

          return {
            ...{ OBJECTID: i.OBJECTID, report_id: i.report_id, GID_0: i.gid1, NAME_0: i.name1, eco_jobs_created: jobsCreated },
            ...i.privateSectorAreaOfLandTab,
            ...i.privateSectorClimateImpactsTab,
            ...i.privateSectorBiodiversityImpactsTab
          };

          //commonPush?.privateSectorResultsAndBenefitsItems!.push(i);
        });
      }
      else {
        return tab2!.countryprivateSectorResultsAndBenefitsItems!.map((i: ICountryPrivateSectorResultsAndBenefitsItem) => {
          i.OBJECTID = -1;
          i.report_id = localState.rb_MainGlobalId;
          if (i.privateSectorAreaOfLandTab.ha_restoration_data == '') {
            i.privateSectorAreaOfLandTab.ha_restoration_data = "0";
          }
          if (i.privateSectorAreaOfLandTab.ha_restoration_data == "0") {
            i.privateSectorAreaOfLandTab.ha_under_resto = 0;
            i.privateSectorAreaOfLandTab.ha_tier = '';
          }
          if (i.privateSectorAreaOfLandTab.ha_restoration_data == "1") {
            i.privateSectorAreaOfLandTab.area_restoration_system = "";
          }
          i.privateSectorAreaOfLandTab.ha_tier = i.privateSectorAreaOfLandTab.ha_tier !== '-999' ? i.privateSectorAreaOfLandTab.ha_tier : '';
          i.privateSectorClimateImpactsTab.co2_tier = i.privateSectorClimateImpactsTab.co2_tier !== '-999' ? i.privateSectorClimateImpactsTab.co2_tier : '';
          i.privateSectorBiodiversityImpactsTab.bio_information = i.privateSectorBiodiversityImpactsTab.bio_information?.toString();
          // Sum of jobs created
          let jobsCreated = 0;
          jobsCreated += i.privateSectorSocioEconomicImpactsTab && i.privateSectorSocioEconomicImpactsTab.psSeasonalCasualOccasional && i.privateSectorSocioEconomicImpactsTab.psSeasonalCasualOccasional.eco_jobs ? Number(i.privateSectorSocioEconomicImpactsTab.psSeasonalCasualOccasional.eco_jobs) : 0;
          //jobsCreated += i.privateSectorSocioEconomicImpactsTab && i.privateSectorSocioEconomicImpactsTab.shortTerm && i.privateSectorSocioEconomicImpactsTab.shortTerm.eco_jobs ? Number(i.privateSectorSocioEconomicImpactsTab.shortTerm.eco_jobs) : 0;
          jobsCreated += i.privateSectorSocioEconomicImpactsTab && i.privateSectorSocioEconomicImpactsTab.psLongTerm && i.privateSectorSocioEconomicImpactsTab.psLongTerm.eco_jobs ? Number(i.privateSectorSocioEconomicImpactsTab.psLongTerm.eco_jobs) : 0;
          //jobsCreated += i.privateSectorSocioEconomicImpactsTab && i.privateSectorSocioEconomicImpactsTab.unspecified && i.privateSectorSocioEconomicImpactsTab.unspecified.eco_jobs ? Number(i.privateSectorSocioEconomicImpactsTab.unspecified.eco_jobs) : 0;

          return {
            ...{ OBJECTID: i.OBJECTID, report_id: i.report_id, GID_0: i.gid0, NAME_0: i.name0, eco_jobs_created: jobsCreated },
            ...i.privateSectorAreaOfLandTab,
            ...i.privateSectorClimateImpactsTab,
            ...i.privateSectorBiodiversityImpactsTab
          };
        });
      }
    }

    return [];
  }

  /**
   * Get results and benefits jobs atts
   * @returns
   */
  const getResultsAndBenefitsJobsAtts = (): { adds: IPrivateSectorSocioEconomicImpactsTab[], updates: IPrivateSectorSocioEconomicImpactsTab[] } => {
    const relatedJobs: { adds: IPrivateSectorSocioEconomicImpactsTab[], updates: IPrivateSectorSocioEconomicImpactsTab[] } = { adds: [], updates: [] };

    if (state) {
      const tab: IPrivateSectorResultsAndBenefitsTab | undefined = state.privateSectorResultsAndBenefitsTab;
      const tab2: ICountriesPrivateSectorResultsAndBenefitsTab | undefined = state.countriesPrivateSectorResultsAndBenefitsTab;

      if (tab && tab.privateSectorResultsAndBenefitsItems && tab.isGlobalMode) {
        if (tab && tab.privateSectorResultsAndBenefitsItems) {
          tab.privateSectorResultsAndBenefitsItems.forEach((i: IPrivateSectorResultsAndBenefitsItem) => {
            //i.report_id = localState.rb_GlobalId;
            // if (i && i.privateSectorSocioEconomicImpactsTab && i.privateSectorSocioEconomicImpactsTab.seasonalCasualOccasional && i.privateSectorSocioEconomicImpactsTab?.seasonalCasualOccasional?.eco_unit === '-999') {
            //   i.privateSectorSocioEconomicImpactsTab.seasonalCasualOccasional.eco_unit = '';
            // }
            i.OBJECTID = -1;
            if (i && i.privateSectorSocioEconomicImpactsTab && i.privateSectorSocioEconomicImpactsTab.psSeasonalCasualOccasional && i.privateSectorSocioEconomicImpactsTab?.psSeasonalCasualOccasional?.eco_tiers === '-999') {
              i.privateSectorSocioEconomicImpactsTab.psSeasonalCasualOccasional.eco_tiers = '';
              i.privateSectorSocioEconomicImpactsTab.psSeasonalCasualOccasional.eco_links = Utils.saveLinkFormat(i.privateSectorSocioEconomicImpactsTab.psSeasonalCasualOccasional.eco_links);
              i.privateSectorSocioEconomicImpactsTab.psSeasonalCasualOccasional.eco_other = Utils.saveLinkFormat(i.privateSectorSocioEconomicImpactsTab.psSeasonalCasualOccasional.eco_other);
            }

            if (i && i.privateSectorSocioEconomicImpactsTab && i.privateSectorSocioEconomicImpactsTab.psLongTerm && i.privateSectorSocioEconomicImpactsTab?.psLongTerm?.eco_tiers === '-999') {
              i.privateSectorSocioEconomicImpactsTab.psLongTerm.eco_tiers = '';
              i.privateSectorSocioEconomicImpactsTab.psLongTerm.eco_links = Utils.saveLinkFormat(i.privateSectorSocioEconomicImpactsTab.psLongTerm.eco_links);
              i.privateSectorSocioEconomicImpactsTab.psLongTerm.eco_other = Utils.saveLinkFormat(i.privateSectorSocioEconomicImpactsTab.psLongTerm.eco_other);
            }

            const item: IPrivateSectorSocioEconomicImpactsTab = {
              isOK: false,
              job_type: i.privateSectorSocioEconomicImpactsTab?.job_type,
              //country_id: i.privateSectorSocioEconomicImpactsTab?.country_id,
              psSeasonalCasualOccasional: i.privateSectorSocioEconomicImpactsTab?.psSeasonalCasualOccasional,
              psLongTerm: i.privateSectorSocioEconomicImpactsTab?.psLongTerm
            };

            relatedJobs.adds.push(item);
          });
        }
      }
      else {
        if (tab2 && tab2.countryprivateSectorResultsAndBenefitsItems) {
          tab2.countryprivateSectorResultsAndBenefitsItems.forEach((iCountry: ICountryPrivateSectorResultsAndBenefitsItem) => {
            iCountry.OBJECTID = -1;
            if (iCountry && iCountry.privateSectorSocioEconomicImpactsTab && iCountry.privateSectorSocioEconomicImpactsTab.psSeasonalCasualOccasional && iCountry.privateSectorSocioEconomicImpactsTab?.psSeasonalCasualOccasional?.eco_tiers === '-999') {
              iCountry.privateSectorSocioEconomicImpactsTab.psSeasonalCasualOccasional.eco_tiers = '';
              iCountry.privateSectorSocioEconomicImpactsTab.psSeasonalCasualOccasional.eco_links = Utils.saveLinkFormat(iCountry.privateSectorSocioEconomicImpactsTab.psSeasonalCasualOccasional.eco_links);
              iCountry.privateSectorSocioEconomicImpactsTab.psSeasonalCasualOccasional.eco_other = Utils.saveLinkFormat(iCountry.privateSectorSocioEconomicImpactsTab.psSeasonalCasualOccasional.eco_other);
            }

            if (iCountry && iCountry.privateSectorSocioEconomicImpactsTab && iCountry.privateSectorSocioEconomicImpactsTab.psLongTerm && iCountry.privateSectorSocioEconomicImpactsTab?.psLongTerm?.eco_tiers === '-999') {
              iCountry.privateSectorSocioEconomicImpactsTab.psLongTerm.eco_tiers = '';
              iCountry.privateSectorSocioEconomicImpactsTab.psLongTerm.eco_links = Utils.saveLinkFormat(iCountry.privateSectorSocioEconomicImpactsTab.psLongTerm.eco_links);
              iCountry.privateSectorSocioEconomicImpactsTab.psLongTerm.eco_other = Utils.saveLinkFormat(iCountry.privateSectorSocioEconomicImpactsTab.psLongTerm.eco_other);
            }

            const itemCountry: IPrivateSectorSocioEconomicImpactsTab = {
              isOK: false,
              job_type: iCountry.privateSectorSocioEconomicImpactsTab?.job_type,
              //country_id: i.privateSectorSocioEconomicImpactsTab?.country_id,
              psSeasonalCasualOccasional: iCountry.privateSectorSocioEconomicImpactsTab?.psSeasonalCasualOccasional,
              psLongTerm: iCountry.privateSectorSocioEconomicImpactsTab?.psLongTerm
            };

            relatedJobs.adds.push(itemCountry);
          });
        }
      }
    }

    return relatedJobs;
  }


  /**
   * Get results and benefits jobs atts
   * @returns
   */
  const getSplitUpValuesAtts = (): { adds: IPrivateSectorSplitUpValues[], updates: IPrivateSectorSplitUpValues[] } => {
    const splitUpValues: { adds: IPrivateSectorSplitUpValues[], updates: IPrivateSectorSplitUpValues[] } = { adds: [], updates: [] };

    if (state) {
      const tab: IPrivateSectorResultsAndBenefitsTab | undefined = state.privateSectorResultsAndBenefitsTab;
      const tab2: ICountriesPrivateSectorResultsAndBenefitsTab | undefined = state.countriesPrivateSectorResultsAndBenefitsTab;

      if (tab && tab.interventionSplitUp.privateSectorSplitUpValues && tab.isGlobalMode) {
        tab.interventionSplitUp.privateSectorSplitUpValues.forEach((i: IPrivateSectorSplitUpValues) => {
          let splitValue: any;
          if (i.splitup_value != undefined || i.splitup_value != '') {
            splitValue = i.splitup_value?.toString().replace(',', '');
            splitValue = parseFloat(splitValue).toLocaleString('es-US', { maximumFractionDigits: 2 });
            i.splitup_value = splitValue;
          }

          i.OBJECTID = -1;
          i.report_rb_id = localState.rb_GlobalId;
          if (i.intervention_type_id != undefined && i.intervention_type_id != '') {
            splitUpValues.adds.push(i);
          }
        });
      }

      if (tab2 && tab2.countryInterventionSplitUp.countryPrivateSectorSplitUpValues) {
        tab2.countryInterventionSplitUp.countryPrivateSectorSplitUpValues.forEach((iCountry: ICountriesPrivateSectorSplitUpValues) => {
          let splitCountryValue: any;
          if (iCountry.splitup_value != undefined || iCountry.splitup_value != '') {
            splitCountryValue = iCountry.splitup_value?.toString().replace(',', '');
            splitCountryValue = parseFloat(splitCountryValue).toLocaleString('es-US', { maximumFractionDigits: 2 });
            iCountry.splitup_value = splitCountryValue;
          }

          iCountry.OBJECTID = -1;
          iCountry.report_rb_id = localState.rb_GlobalId;
          if (iCountry.intervention_type_id != undefined && iCountry.intervention_type_id != '') {
            splitUpValues.adds.push(iCountry);
          }
        });
      }
    }

    return splitUpValues;
  }

  const getCountryIndicatorAtts = (): { adds: IReportCountriesIndicators[], updates: IReportCountriesIndicators[] } => {
    const countryIndicatorList: { adds: IReportCountriesIndicators[], updates: IReportCountriesIndicators[] } = { adds: [], updates: [] };

    if (state) {
      const tab: IRestorationPledgeTrackingDetailsTab | undefined = state.restorationPledgeTrackingDetailsTab;

      if (tab && tab.sectorReportCountries.privateSectorReportCountriesIndicators) {
        tab.sectorReportCountries.privateSectorReportCountriesIndicators.forEach((i: IReportCountriesIndicators) => {
          i.OBJECTID = -1;
          i.report_id = localState.rb_MainGlobalId;
          countryIndicatorList.adds.push(i);
        });
      }
    }

    return countryIndicatorList;
  }

  // /**
  //  * Call export
  //  * @returns 
  //  */
  const callExport = async () => {
    try {
      setExportLoading(true);
      const objReportData: IEditReportState = { ...state };
      const objReportHeaders: IExportReportFeature = { ...stateExport };
      let res: any;
      res = await exportRequestExcel(objReportHeaders, objReportData);
      setExportLoading(false);

      // Reload report
      //setFetchReportData({});

      toast.success(t('newReport.exportSuccess'));
      return Promise.resolve(res);
    }
    catch (err: any) {
      console.error(err);
      setExportLoading(false);
      toast.error(t('newReport.exportError'));
      return Promise.reject(err);
    }
  }


  // /**
  //  * Call save data
  //  * @param isSubmitMode 
  //  * @returns 
  //  */
  const callSaveData = async (isSubmitMode: boolean = false): Promise<any> => {
    try {
      const generalInfoAtts: any = getGeneralInfoAtts();
      const restorationPledgeAtts: any = getRestorationPledgeTrackingAtts();
      const restorationPledgeTrackingDetailsAtts = getRestorationPledgeTrackingDetailsAtts();
      const CountryIndicatorAtts = getCountryIndicatorAtts();
      const successFactorsPoliciesAtts = getPrivateSectorSuccessFactorsPoliciesAtts();
      const successFactorsPlanningMethodologiesAtts = getSuccessFactorsPlanningMethodologiesAtts();
      const successFactorsFinancialFlowsAtts = getSuccessFactorsFinancialFlowsAtts();
      const successFactorsMonitoringSystemsAtts = getSuccessFactorsMonitoringSystemsAtts();
      const resultsAndBenefitsAtts = getResultsAndBenefitsAtts();
      const resultsAndBenefitsJobsAtts = getResultsAndBenefitsJobsAtts();
      const splitUpValueAtts = getSplitUpValuesAtts();

      // Report main atts      
      const reportMainAtts = { attributes: { ...generalInfoAtts, ...restorationPledgeAtts, ...restorationPledgeTrackingDetailsAtts } };

      if (isSubmitMode) {
        reportMainAtts.attributes[ConfigService.getConfig().agol.operationalLayers.reportMain.fields.submitted] = ConfigService.getConfig().agol.operationalLayers.reportMain.reportSubmittedCode;
      }

      const res = await QueryService.savePrivateSectorEdits(
        // 1) Report main
        {
          updates: [reportMainAtts]
        },

        //2) Country Indicators
        {
          addsCountryIndicator: CountryIndicatorAtts.adds,
          updatesCountryIndicator: CountryIndicatorAtts.updates,
          deletesCountryIndicator: state.restorationPledgeTrackingDetailsTab ? state.restorationPledgeTrackingDetailsTab.sectorReportCountries.deleteCountriesIndicatorObjetIds : []
        },

        // 3) Success factors
        {
          // 2.1) Policies
          // policiesAndStrategies: {
          //   adds: successFactorsPoliciesAtts!.adds,
          //  // adds: successFactorsPoliciesAtts.adds,
          //   deletes: state.privateSectorSuccessFactorsTab && state.privateSectorSuccessFactorsTab.policiesAndStrategiesTab ? state.privateSectorSuccessFactorsTab.policiesAndStrategiesTab.deleteObjetIds : []
          // },
          policiesAndStrategies: {
            adds: successFactorsPoliciesAtts.adds,
            // adds: successFactorsPoliciesAtts && successFactorsPoliciesAtts.length ? 
            // successFactorsPoliciesAtts.map( (i: ISuccessFactorsPolicyStrategies) => {

            //   return {attributes: i};
            //  //return {i};
            // }) : [],
            deletes: state.privateSectorSuccessFactorsTab && state.privateSectorSuccessFactorsTab.policiesAndStrategiesTab ? state.privateSectorSuccessFactorsTab.policiesAndStrategiesTab.deleteObjetIds : []
          },

          // 2.3) Technical planning
          planningMethodologies: {
            adds: successFactorsPlanningMethodologiesAtts.adds,
            deletes: state.privateSectorSuccessFactorsTab && state.privateSectorSuccessFactorsTab.privateSectorTechnicalPlanningTab ? state.privateSectorSuccessFactorsTab.privateSectorTechnicalPlanningTab.deleteObjetIds : []
          },

          // planningMethodologies: {
          //   adds: successFactorsPlanningMethodologiesAtts && successFactorsPlanningMethodologiesAtts.length ? 
          //   successFactorsPlanningMethodologiesAtts.map( (i: IPrivateSectorSuccessFactorsPlanningMethodology) => {
          //     return {attributes: i};
          //   }) : [],
          //   deletes: state.privateSectorSuccessFactorsTab && state.privateSectorSuccessFactorsTab.privateSectorTechnicalPlanningTab ? state.privateSectorSuccessFactorsTab.privateSectorTechnicalPlanningTab.deleteObjetIds : []
          // },

          // 2.2) Financial flows
          financialFlows: {
            adds: successFactorsFinancialFlowsAtts.adds,
            deletes: state.privateSectorSuccessFactorsTab && state.privateSectorSuccessFactorsTab.privateSectorFinancialFlowsTab ? state.privateSectorSuccessFactorsTab.privateSectorFinancialFlowsTab.deleteObjetIds : []
            // adds: successFactorsFinancialFlowsAtts.filter((i: IPrivateSectorSuccessFactorsFinancialFlow) => i.report_id && !i.OBJECTID).map((item: IPrivateSectorSuccessFactorsFinancialFlow) => { return { attributes: item }; }),
            // updates: successFactorsFinancialFlowsAtts.filter((i: IPrivateSectorSuccessFactorsFinancialFlow) => i.report_id && i.OBJECTID).map((item: IPrivateSectorSuccessFactorsFinancialFlow) => { return { attributes: item }; })
          },

          // 2.4) Monitoring
          monitoringSystems: {
            adds: successFactorsMonitoringSystemsAtts.adds,
            deletes: state.privateSectorSuccessFactorsTab && state.privateSectorSuccessFactorsTab.privateSectorMonitoringTab ? state.privateSectorSuccessFactorsTab.privateSectorMonitoringTab.deleteObjetIds : []
          }
          // monitoringSystems: {
          //   adds: successFactorsMonitoringSystemsAtts && successFactorsMonitoringSystemsAtts.length ? 
          //   successFactorsMonitoringSystemsAtts.map( (i: IPrivateSectorSuccessFactorsMonitoringSystem) => {
          //     return {attributes: i};
          //   }) : [],
          //   deletes: state.privateSectorSuccessFactorsTab && state.privateSectorSuccessFactorsTab.privateSectorMonitoringTab ? state.privateSectorSuccessFactorsTab.privateSectorMonitoringTab.deleteObjetIds : []
          // }
        },

        //4) Results and benefits
        {
          adds: resultsAndBenefitsAtts && resultsAndBenefitsAtts.length ? resultsAndBenefitsAtts.filter((i: any) => !i.OBJECTID || i.OBJECTID < 0).map((i: any) => { return { attributes: i }; }) : [],
          updates: resultsAndBenefitsAtts && resultsAndBenefitsAtts.length ? resultsAndBenefitsAtts.filter((i: any) => i.OBJECTID && i.OBJECTID > 0).map((i: any) => { return { attributes: i }; }) : [],
          deletes: state.privateSectorResultsAndBenefitsTab ? state.privateSectorResultsAndBenefitsTab.deleteRbObjetIds : [],
          addsJobs: resultsAndBenefitsJobsAtts.adds,
          updatesJobs: resultsAndBenefitsJobsAtts.updates,
          deletesJobs: state.privateSectorResultsAndBenefitsTab ? state.privateSectorResultsAndBenefitsTab.deleteRbJobsObjetIds : [],
          addsSplitUpValue: splitUpValueAtts.adds,
          updatesSplitUpValue: splitUpValueAtts.updates,
          deletesSplitUpValue: state.privateSectorResultsAndBenefitsTab ? state.privateSectorResultsAndBenefitsTab.interventionSplitUp.deleteRbHaRestoSplitObjetIds : []
        }
        // {
        //   addsCountryIndicator: CountryIndicatorAtts.adds,
        //   updatesCountryIndicator: CountryIndicatorAtts.updates,
        //   deletesCountryIndicator: state.restorationPledgeTrackingDetailsTab ? state.restorationPledgeTrackingDetailsTab.sectorReportCountries.deleteCountriesIndicatorObjetIds : []
        // }
      );

      return Promise.resolve(res);
    } catch (err: any) {
      console.error(err);
      return Promise.reject(err);
    }
  }

  /**
   * Handle save draft
   */
  const onSaveDraft = async () => {
    try {
      setSaveDraftLoading(true);
      const res: any = await callSaveData();
      setSaveDraftLoading(false);
      toast.success(t('newReport.saveDraftSuccess'));

      // Reload report
      //setFetchReportData({});

    } catch (err: any) {
      setSaveDraftLoading(false);
      toast.error(t('newReport.saveDraftError'));
    }
  }

  const exportRequestExcel = async (headerMappingDoc: any, MappingDoc: any) => {
    let fileName = ConfigService.getConfig().exportPSFileName;

    let sheetName1 = t('newReport.generalInfo.exportTabName');
    let sheetName2 = t('newReport.restorationPledge.exportTabName');
    let sheetName3 = t('newReport.restorationPledgeDetails.exportTabName');
    let sheetName4 = t('newReport.successFactors.exportPolicyTabName');
    let sheetName5 = t('newReport.successFactors.exportMethodologyTabName');
    let sheetName6 = t('newReport.successFactors.exportFinancialTabName');
    let sheetName7 = t('newReport.successFactors.exportMonitoringTabName');
    let sheetName8 = t('newReport.resultsAndBenefits.exportAreaTabName');
    let sheetName9 = t('newReport.resultsAndBenefits.exportClimateTabName');
    let sheetName10 = t('newReport.resultsAndBenefits.exportBiodiversityTabName');
    let sheetName11 = t('newReport.resultsAndBenefits.exportEconomyTabName');

    // // trim sheetname if it exceeds 31 characters
    if (sheetName1.length > 31) {
      sheetName1 = sheetName1.substring(0, 28) + "...";
    }
    let sheetNames = [sheetName1, sheetName2, sheetName3, sheetName4, sheetName5, sheetName6, sheetName7, sheetName8, sheetName9, sheetName10, sheetName11];
    let reportHeader: any = [];
    let reportData: any = [];
    let excelData: any = [];
    let excelData1: any;
    let excelData2: any;
    let excelData3: any;
    let excelData4: any;
    let excelData5: any;
    let excelData6: any;
    let excelData7: any;
    let excelData8: any;
    let excelData9: any;
    let excelData10: any;
    let excelData11: any;


    for (let k = 0; k < 11; k++) {
      if (k == 0) {
        reportHeader = headerMappingDoc.generalInfoTab;
        reportData = MappingDoc.generalInfoTab;
        excelData1 = await generateRequestExcel(reportHeader, reportData, sheetName1);
        excelData.push(excelData1);
      }
      if (k == 1) {
        reportHeader = headerMappingDoc.restorationPledgeTrackingTab;
        reportData = MappingDoc.restorationPledgeTrackingTab;
        excelData2 = await generateRequestExcel(reportHeader, reportData, sheetName2);
        excelData.push(excelData2);
      }

      else if (k == 2) {
        if (MappingDoc.restorationPledgeTrackingDetailsTab.location_specific == 1) {
          reportHeader = headerMappingDoc.privateSectorReportCountriesIndicators;
          reportData = MappingDoc!.restorationPledgeTrackingDetailsTab!.sectorReportCountries!.privateSectorReportCountriesIndicators;
        }
        else {
          reportHeader = headerMappingDoc.restorationPledgeTrackingDetailsTab;
          reportData = MappingDoc.restorationPledgeTrackingDetailsTab;
        }
        excelData3 = await generateRequestExcel(reportHeader, reportData, sheetName3);
        excelData.push(excelData3);
      }
      else if (k == 3) {
        reportHeader = headerMappingDoc.PolicyStrategies;
        reportData = MappingDoc.privateSectorSuccessFactorsTab.policiesAndStrategiesTab.policiesAndStrategies;
        excelData4 = await generateRequestExcel(reportHeader, reportData, sheetName4);
        excelData.push(excelData4);
      }
      else if (k == 4) {
        reportHeader = headerMappingDoc.PlanningMethodology;
        reportData = MappingDoc.privateSectorSuccessFactorsTab.privateSectorTechnicalPlanningTab.privateSectorPlanningMethodologies;
        excelData5 = await generateRequestExcel(reportHeader, reportData, sheetName5);
        excelData.push(excelData5);
      }
      else if (k == 5) {
        reportHeader = headerMappingDoc.FinancialFlow;
        reportData = MappingDoc.privateSectorSuccessFactorsTab.privateSectorFinancialFlowsTab.totalDomesticPublicExpenditure;
        excelData6 = await generateRequestExcel(reportHeader, reportData, sheetName6);
        excelData.push(excelData6);
      }
      else if (k == 6) {
        reportHeader = headerMappingDoc.MonitoringSystem;
        reportData = MappingDoc.privateSectorSuccessFactorsTab.privateSectorMonitoringTab.privateSectorMonitoringSystems;
        excelData7 = await generateRequestExcel(reportHeader, reportData, sheetName7);
        excelData.push(excelData7);
      }
      else if (k == 7) {
        let reportAreaData: any = [];
        reportHeader = headerMappingDoc.AreaOfLandTab;
        if (MappingDoc.privateSectorResultsAndBenefitsTab.privateSectorResultsAndBenefitsItems.length > 0) {
          let reportAreaLandData = MappingDoc.privateSectorResultsAndBenefitsTab.privateSectorResultsAndBenefitsItems[0].privateSectorAreaOfLandTab;
          let reportSplitData = MappingDoc.privateSectorResultsAndBenefitsTab.interventionSplitUp.privateSectorSplitUpValues;
          reportAreaData = [reportAreaLandData, reportSplitData];
        }
        excelData8 = await generateRequestExcel(reportHeader, reportAreaData, sheetName8);
        excelData.push(excelData8);
      }
      else if (k == 8) {
        reportHeader = headerMappingDoc.ClimateImpactsTab;
        let reportClimateData: any[] = [];
        if (MappingDoc.privateSectorResultsAndBenefitsTab.privateSectorResultsAndBenefitsItems.length > 0) {
          reportClimateData = MappingDoc.privateSectorResultsAndBenefitsTab.privateSectorResultsAndBenefitsItems[0].privateSectorClimateImpactsTab;
        }
        else {
          reportClimateData = [];
        }
        excelData9 = await generateRequestExcel(reportHeader, reportClimateData, sheetName9);
        excelData.push(excelData9);
      }
      else if (k == 9) {
        reportHeader = headerMappingDoc.BiodiversityImpactsTab;
        let reportBiodiversityData: any[] = [];
        if (MappingDoc.privateSectorResultsAndBenefitsTab.privateSectorResultsAndBenefitsItems.length > 0) {
          reportBiodiversityData = MappingDoc.privateSectorResultsAndBenefitsTab.privateSectorResultsAndBenefitsItems[0].privateSectorBiodiversityImpactsTab;
        }
        else {
          reportBiodiversityData = [];
        }
        excelData10 = await generateRequestExcel(reportHeader, reportBiodiversityData, sheetName10);
        excelData.push(excelData10);
      }
      else if (k == 10) {
        let reportEcoData: any;
        let reportEconomyData: any[] = [];
        let i = 0;
        reportHeader = headerMappingDoc.psSocioEconomicImpactItem;
        if (MappingDoc.privateSectorResultsAndBenefitsTab.privateSectorResultsAndBenefitsItems.length > 0) {

          if (MappingDoc.privateSectorResultsAndBenefitsTab.privateSectorResultsAndBenefitsItems[0].privateSectorSocioEconomicImpactsTab?.psSeasonalCasualOccasional) {
            reportEconomyData[i] = (MappingDoc.privateSectorResultsAndBenefitsTab.privateSectorResultsAndBenefitsItems[0].privateSectorSocioEconomicImpactsTab?.psSeasonalCasualOccasional);
            i = i + 1;
          }
          if (MappingDoc.privateSectorResultsAndBenefitsTab.privateSectorResultsAndBenefitsItems[0].privateSectorSocioEconomicImpactsTab?.psLongTerm) {
            reportEconomyData[i] = (MappingDoc.privateSectorResultsAndBenefitsTab.privateSectorResultsAndBenefitsItems[0].privateSectorSocioEconomicImpactsTab?.psLongTerm);
            i = i + 1;
          }
          if (i > 1) {
            reportEcoData = [reportEconomyData[0], reportEconomyData[1]];
          }
          if (i == 1) {
            reportEcoData = reportData[0];
          }
        }
        else {
          reportEcoData = [];
        }
        excelData11 = await generateRequestExcel(reportHeader, reportEcoData, sheetName11);
        excelData.push(excelData11);
      }
    }
    await parseMultipleSheetDataToExcel(excelData, fileName, sheetNames);
  }


  const generateExcelCell = async (value: any) => {
    var cell = value.toString();

    return cell;
  }


  const generateRequestExcel = async (headerMappingDoc: any, MappingDoc: any, sheetName: any) => {
    let requestExcelHeaderKey: any = [];
    let requestExcelHeaders: any = [];
    let excelData: any = [];
    let pldgeVal: any = [];
    let ecoSysVal: any = [];
    let pledgImplementVal: any = [];
    let actionVal: any = [];
    let impactVal: any = [];
    let restoPrinciplesVal: any = [];
    let confidenceLevelVal: any = [];
    let financialSupportVal: any = [];
    let monitoringTrackedVal: any = [];
    let cO2EstimationSystemVal: any = [];
    let cO2RestorationInterventionVal: any = [];
    let restorationAimsVal: any = [];
    let jobStakesholdersVal: any = [];
    let interventionTypesVal: any = [];

    if (sheetName === t('newReport.restorationPledge.exportTabName')) {
      // Set PledgeInitiative
      pldgeVal = await setPledgeInitiativeList();

      // Set Ecosystems
      ecoSysVal = await setEcosystemList();

      // Set PledgImplement
      pledgImplementVal = await setPledgImplementList();
    }

    if (sheetName === t('newReport.restorationPledgeDetails.exportTabName')) {
      // Set Action Indicators
      actionVal = await setActionIndicatorList();

      // Set Impact Indicators
      impactVal = await setImpactIndicatorList();
    }

    if (sheetName === t('newReport.successFactors.exportMethodologyTabName')) {
      // Set Restoration Principles
      restoPrinciplesVal = await setrestorationPrinciplesList();
    }

    if (sheetName === t('newReport.successFactors.exportFinancialTabName')) {
      // Set Confidence Level
      confidenceLevelVal = await setconfidenceLevelList();

      // Set Financial Support
      financialSupportVal = await setfinancialSupportList();
    }

    if (sheetName === t('newReport.successFactors.exportMonitoringTabName')) {
      // Set Monitoring Tracked Element
      monitoringTrackedVal = await setmonitoringTrackedElementList();
    }

    if (sheetName === t('newReport.resultsAndBenefits.exportAreaTabName')) {
      // Set Confidence Level
      confidenceLevelVal = await setconfidenceLevelList();

      // Set InterventionTypes
      interventionTypesVal = await setinterventionTypesList();

      // Set Ecosystems
      ecoSysVal = await setEcosystemList();
    }

    if (sheetName === t('newReport.resultsAndBenefits.exportClimateTabName')) {
      // Set Confidence Level
      confidenceLevelVal = await setconfidenceLevelList();

      // Set CO2 Estimation System
      cO2EstimationSystemVal = await setcO2EstimationSystemList();

      // Set CO2 Restoration Intervention
      cO2RestorationInterventionVal = await setcO2RestorationInterventionList();

      // Set Restoration Aims
      restorationAimsVal = await setrestorationAimsList();
    }

    if (sheetName === t('newReport.resultsAndBenefits.exportEconomyTabName')) {
      // Set JobStakesholders
      jobStakesholdersVal = await setjobStakesholdersList();

      // Set Confidence Level
      confidenceLevelVal = await setconfidenceLevelList();
    }

    // Getting excel headers
    Object.entries(headerMappingDoc).map((key, i) => {
      requestExcelHeaderKey = [...requestExcelHeaderKey, key[0]]
      requestExcelHeaders = [...requestExcelHeaders, key[1]]
    }
    );
    excelData.push(requestExcelHeaders);


    // Getting excel data based on the  headers
    if (MappingDoc.length !== undefined && MappingDoc.length > 0) {
      let arrMappingDoc: any = [];

      if (sheetName == "Pledge Impl. Tracking Details") {
        arrMappingDoc = MappingDoc.map((objarrMappingDoc: any) => {
          return { ...objarrMappingDoc, location_specific: 'Yes' };
        });
      }
      else if (sheetName == t('newReport.resultsAndBenefits.exportAreaTabName')) {
        let areaData: any = [];
        if (MappingDoc[0].length != undefined && MappingDoc[0].length > 0) {
          MappingDoc[0].map((objarrAreaDoc: any, index: number) => {
            if (MappingDoc[1] != undefined) {
              arrMappingDoc = MappingDoc[1].map((objarrSplitDoc: any, i: number) => {
                if (index == 0) {
                }
                else {

                }
              });
            }
            else {
              arrMappingDoc = MappingDoc[0];
            }
          });
        }
        else {
          const dummyEcosystemData = { '1000': 'Coasts and mangroves', '2000': 'Deserts and semi-deserts', '3000': 'Farmlands and mixed-use areas', '4000': 'Forests and woodlands', '5000': 'Grasslands, shrublands and savannahs', '6000': 'Peatlands', '7000': 'Rivers, streams, lakes (wetlands)', '8000': 'Urban areas' };

          MappingDoc[1].map((objarrMappingDoc: any, i: number) => {
            if (i == 0) {
              Object.entries(objarrMappingDoc).map((eachKey, i) => {

                if (eachKey[0] == "intervention_type_id") {
                  let splitInterventionData: any = [];
                  let splitArrInterventionData: any = [];
                  if (interventionTypesVal && eachKey[1] != undefined && eachKey[1] != null) {
                    Object.entries(dummyEcosystemData).map((key: any, value: any) => {
                      if (key[0] == eachKey[1]) {
                        splitInterventionData.push(key[1]);
                      }
                    });
                    if (splitInterventionData.length == 0) {
                      interventionTypesVal.forEach((ele: any, i: number) => {
                        splitArrInterventionData = Array(eachKey[1]);
                        if (splitArrInterventionData[0].includes(ele.key_)) {
                          splitInterventionData.push(ele.value);
                        }
                      });
                    }
                    eachKey[1] = splitInterventionData.toString();
                  }

                  areaData = { ...MappingDoc[0], intervention_type_id: eachKey[1] };
                }
                if (eachKey[0] == "splitup_value") {
                  areaData = { ...areaData, splitup_value: eachKey[1] };
                }
              });

            }
            else {
              const dummyAreaData = { 'ha_restoration_data': '', 'ha_under_resto': '', 'ha_tier': '', 'ha_information': '', 'ha_links': '' };
              const dummyEcosystemData = { '1000': 'Coasts and mangroves', '2000': 'Deserts and semi-deserts', '3000': 'Farmlands and mixed-use areas', '4000': 'Forests and woodlands', '5000': 'Grasslands, shrublands and savannahs', '6000': 'Peatlands', '7000': 'Rivers, streams, lakes (wetlands)', '8000': 'Urban areas' };
              Object.entries(objarrMappingDoc).map((eachKey, i) => {
                if (requestExcelHeaderKey.includes(eachKey[0])) {
                  if (eachKey[0] == "intervention_type_id") {
                    let splitInterventionData: any = [];
                    let splitArrInterventionData: any = [];
                    if (interventionTypesVal && eachKey[1] != undefined && eachKey[1] != null) {
                      Object.entries(dummyEcosystemData).map((key: any, value: any) => {
                        if (key.includes(eachKey[1])) {
                          splitInterventionData.push(key[1]);
                        }
                      });
                      if (splitInterventionData.length == 0) {
                        interventionTypesVal.forEach((ele: any, i: number) => {
                          splitArrInterventionData = Array(eachKey[1]);
                          if (splitArrInterventionData[0].includes(ele.key_)) {
                            splitInterventionData.push(ele.value);
                          }
                        });
                      }
                      eachKey[1] = splitInterventionData.toString();
                    }

                    areaData = { ...dummyAreaData, intervention_type_id: eachKey[1] }
                  }
                  if (eachKey[0] == "splitup_value") {
                    areaData = { ...areaData, splitup_value: eachKey[1] }
                  }
                }
              });
            }
            arrMappingDoc.push(areaData);
          });
        }
      }
      else {
        arrMappingDoc = MappingDoc;
      }

      for (let m = 0; m < arrMappingDoc!.length; m++) {
        let requestDataCellRow: any = [];
        Object.entries(arrMappingDoc[m]).map((eachKey, i) => {
          let requestData: any = [];
          if (requestExcelHeaderKey.includes(eachKey[0])) {
            if (eachKey[0] === "eco_type") {
              eachKey[1] = eachKey[1] === "1" ? t('newReport.resultsAndBenefits.socioEconomicImpactsHeaderLabel1') : t('newReport.resultsAndBenefits.socioEconomicImpactsHeaderLabel3');
            }

            if (eachKey[0] === "ha_restoration_data") {
              eachKey[1] = eachKey[1] === null ? '' : eachKey[1] == "1" ? "Yes" : (eachKey[1] == "0" ? "No" : "")
            }

            if (eachKey[0] === "action_indicator" || eachKey[0] === "action_indicators") {
              let splitActionData: any = [];
              let splitArrActionData: any = [];
              if (actionVal && eachKey[1] != undefined && eachKey[1] != null) {
                actionVal.forEach((ele: any, i: number) => {
                  splitArrActionData = Array(eachKey[1]);
                  if (splitArrActionData[0].includes(ele.key_)) {
                    splitActionData.push(ele.value);
                  }
                });
                eachKey[1] = splitActionData.toString().replaceAll(',', ', ');
              }
            }

            if (eachKey[0] === "impact_indicator" || eachKey[0] === "impact_indicators") {
              let splitImpactData: any = [];
              let splitArrImpactData: any = [];
              if (impactVal && eachKey[1] != undefined && eachKey[1] != null) {
                impactVal.forEach((ele: any, i: number) => {
                  splitArrImpactData = Array(eachKey[1]);
                  if (splitArrImpactData[0].includes(ele.key_)) {
                    splitImpactData.push(ele.value);
                  }
                });
                eachKey[1] = splitImpactData.toString().replaceAll(',', ', ');
              }
            }

            if (eachKey[0] === "ecosystem_resto_principles") {
              let splitRestoPrincipleData: any = [];
              let splitArrRestoPrincipleData: any = [];
              if (restoPrinciplesVal && eachKey[1] != undefined && eachKey[1] != null) {
                restoPrinciplesVal.forEach((ele: any, i: number) => {
                  splitArrRestoPrincipleData = Array(eachKey[1]);
                  if (splitArrRestoPrincipleData[0].includes(ele.key_)) {
                    splitRestoPrincipleData.push(ele.value);
                  }
                });
                eachKey[1] = splitRestoPrincipleData.toString().replaceAll(',', ', ');
              }
            }

            if (eachKey[0] === "tier") {
              let splitTierData: any = [];
              let splitArrTierData: any = [];
              if (confidenceLevelVal && eachKey[1] != undefined && eachKey[1] != null) {
                confidenceLevelVal.forEach((ele: any, i: number) => {
                  splitArrTierData = Array(eachKey[1]);
                  if (splitArrTierData[0].includes(ele.key_)) {
                    splitTierData.push(ele.value);
                  }
                });
                eachKey[1] = splitTierData.toString().replaceAll(',', ', ');
              }
            }

            if (eachKey[0] === "financial_support_used") {
              let splitfinancialSupportData: any = [];
              let splitArrfinancialSupportData: any = [];
              if (financialSupportVal && eachKey[1] != undefined && eachKey[1] != null) {
                financialSupportVal.forEach((ele: any, i: number) => {
                  splitArrfinancialSupportData = Array(eachKey[1]);
                  if (splitArrfinancialSupportData[0].includes(ele.key_)) {
                    splitfinancialSupportData.push(ele.value);
                  }
                });
                eachKey[1] = splitfinancialSupportData.toString().replaceAll(',', ', ');
              }
            }

            if (eachKey[0] === "ha_tier") {
              let splitHaTierData: any = [];
              let splitArrHaTierData: any = [];
              if (confidenceLevelVal && eachKey[1] != undefined && eachKey[1] != null) {
                confidenceLevelVal.forEach((ele: any, i: number) => {
                  splitArrHaTierData = Array(eachKey[1]);
                  if (splitArrHaTierData[0].includes(ele.key_)) {
                    splitHaTierData.push(ele.value);
                  }
                });
                eachKey[1] = splitHaTierData.toString().replaceAll(',', ', ');
              }
            }

            if (eachKey[0] === "track_list") {
              let splitmonitoringTrackedData: any = [];
              let splitArrmonitoringTrackedData: any = [];
              if (monitoringTrackedVal && eachKey[1] != undefined && eachKey[1] != null) {
                monitoringTrackedVal.forEach((ele: any, i: number) => {
                  splitArrmonitoringTrackedData = Array(eachKey[1]);
                  if (splitArrmonitoringTrackedData[0].includes(ele.key_)) {
                    splitmonitoringTrackedData.push(ele.value);
                  }
                });
                eachKey[1] = splitmonitoringTrackedData.toString().replaceAll(',', ', ');
              }
            }

            if (eachKey[0] === "jobs_stakeholders") {
              let splitJobStakeholdersData: any = [];
              let splitArrJobStakeholdersData: any = [];
              if (jobStakesholdersVal && eachKey[1] != undefined && eachKey[1] != null) {
                jobStakesholdersVal.forEach((ele: any, i: number) => {
                  splitArrJobStakeholdersData = Array(eachKey[1]);
                  if (splitArrJobStakeholdersData[0].includes(ele.key_)) {
                    splitJobStakeholdersData.push(ele.value);
                  }
                });
                eachKey[1] = splitJobStakeholdersData.toString().replaceAll(',', ', ');
              }
            }

            if (eachKey[0] === "eco_tiers") {
              let splitJobLevelData: any = [];
              let splitArrJobLevelData: any = [];
              if (confidenceLevelVal && eachKey[1] != undefined && eachKey[1] != null) {
                confidenceLevelVal.forEach((ele: any, i: number) => {
                  splitArrJobLevelData = Array(eachKey[1]);
                  if (splitArrJobLevelData[0].includes(ele.key_)) {
                    splitJobLevelData.push(ele.value);
                  }
                });
                eachKey[1] = splitJobLevelData.toString().replaceAll(',', ', ');
              }
            }
            if (eachKey[0] === "bio_information" && eachKey[1] != undefined && eachKey[1] != null) {
              eachKey[1] = Utils.addSpace(eachKey[1]);
            }

            requestData = eachKey[1] == null ? '' : Utils.removeHTMLTag(eachKey[1]);
            requestDataCellRow = [...requestDataCellRow, requestData.replace('&nbsp;', '')];
          }
        });

        excelData.push(requestDataCellRow);
      }
    }
    else {
      let requestDataCellRow: any = [];
      Object.entries(MappingDoc).map((eachKey, i) => {
        let requestData: any = [];
        if (requestExcelHeaderKey.includes(eachKey[0])) {

          if (eachKey[0] === "is_previously_reported") {
            eachKey[1] = eachKey[1] === null ? '' : eachKey[1] == "1" ? t("newReport.restorationPledge.yesReported") : (eachKey[1] == "0" ? t("newReport.restorationPledge.noReported") : "")
          }

          if (eachKey[0] === "linked_init") {
            let splitData: any = [];
            let splitArrData: any = [];
            if (pldgeVal && eachKey[1] != undefined && eachKey[1] != null) {
              pldgeVal.forEach((ele: any, i: number) => {
                splitArrData = Array(eachKey[1]);
                if (splitArrData[0].includes(ele.key_)) {
                  splitData.push(ele.value);
                }
              });
              eachKey[1] = splitData.toString().replaceAll(',', ', ');
            }
          }

          if (eachKey[0] === "ecosystems") {
            let splitEcoData: any = [];
            let splitArrEcoData: any = [];
            if (ecoSysVal && eachKey[1] != undefined && eachKey[1] != null) {
              ecoSysVal.forEach((ele: any, i: number) => {
                splitArrEcoData = Array(eachKey[1]);
                if (splitArrEcoData[0].includes(ele.key_)) {
                  splitEcoData.push(ele.value);
                }
              });
              eachKey[1] = splitEcoData.toString().replaceAll(',', ', ');
            }
          }

          if (eachKey[0] === "pledge_implementation") {
            let splitPldgImpData: any = [];
            let splitArrPldgImpData: any = [];
            if (pledgImplementVal && eachKey[1] != undefined && eachKey[1] != null) {
              pledgImplementVal.forEach((ele: any, i: number) => {
                splitArrPldgImpData = Array(eachKey[1]);
                if (splitArrPldgImpData[0].includes(ele.key_)) {
                  splitPldgImpData.push(ele.value);
                }
              });
              eachKey[1] = splitPldgImpData.toString().replaceAll(',', ', ');
            }
          }

          if (eachKey[0] === "tier") {
            let splitTierData: any = [];
            let splitArrTierData: any = [];
            if (confidenceLevelVal && eachKey[1] != undefined && eachKey[1] != null) {
              confidenceLevelVal.forEach((ele: any, i: number) => {
                splitArrTierData = Array(eachKey[1]);
                if (splitArrTierData[0].includes(ele.key_)) {
                  splitTierData.push(ele.value);
                }
              });
              eachKey[1] = splitTierData.toString().replaceAll(',', ', ');
            }
          }

          if (eachKey[0] === "financial_support_used") {
            let splitfinancialSupportData: any = [];
            let splitArrfinancialSupportData: any = [];
            if (financialSupportVal && eachKey[1] != undefined && eachKey[1] != null) {
              financialSupportVal.forEach((ele: any, i: number) => {
                splitArrfinancialSupportData = Array(eachKey[1]);
                if (splitArrfinancialSupportData[0].includes(ele.key_)) {
                  splitfinancialSupportData.push(ele.value);
                }
              });
              eachKey[1] = splitfinancialSupportData.toString().replaceAll(',', ', ');
            }
          }

          if (eachKey[0] === "ha_tier") {
            let splitHaTierData: any = [];
            let splitArrHaTierData: any = [];
            if (confidenceLevelVal && eachKey[1] != undefined && eachKey[1] != null) {
              confidenceLevelVal.forEach((ele: any, i: number) => {
                splitArrHaTierData = Array(eachKey[1]);
                if (splitArrHaTierData[0].includes(ele.key_)) {
                  splitHaTierData.push(ele.value);
                }
              });
              eachKey[1] = splitHaTierData.toString().replaceAll(',', ', ');
            }
          }

          if (eachKey[0] === "co2_tier") {
            let splitCO2TierData: any = [];
            let splitArrCO2TierData: any = [];
            if (confidenceLevelVal && eachKey[1] != undefined && eachKey[1] != null) {
              confidenceLevelVal.forEach((ele: any, i: number) => {
                splitArrCO2TierData = Array(eachKey[1]);
                if (splitArrCO2TierData[0].includes(ele.key_)) {
                  splitCO2TierData.push(ele.value);
                }
              });
              eachKey[1] = splitCO2TierData.toString().replaceAll(',', ', ')
            }
          }

          if (eachKey[0] === "co2_systems") {
            let splitCO2Data: any = [];
            let splitArrCO2Data: any = [];
            if (cO2EstimationSystemVal && eachKey[1] != undefined && eachKey[1] != null) {
              cO2EstimationSystemVal.forEach((ele: any, i: number) => {
                splitArrCO2Data = Array(eachKey[1]);
                if (splitArrCO2Data[0].includes(ele.key_)) {
                  splitCO2Data.push(ele.value);
                }
              });
              eachKey[1] = splitCO2Data.toString().replaceAll(',', ', ');
            }
          }

          if (eachKey[0] === "co2_restoration_interventions") {
            let splitCO2RestoData: any = [];
            let splitArrCO2RestoData: any = [];
            if (cO2RestorationInterventionVal && eachKey[1] != undefined && eachKey[1] != null) {
              cO2RestorationInterventionVal.forEach((ele: any, i: number) => {
                splitArrCO2RestoData = Array(eachKey[1]);
                if (splitArrCO2RestoData[0].includes(ele.key_)) {
                  splitCO2RestoData.push(ele.value);
                }
              });
              eachKey[1] = splitCO2RestoData.toString().replaceAll(',', ', ');
            }
          }

          if (eachKey[0] === "restoration_interventions_aim") {
            let splitCO2RestoAimData: any = [];
            let splitArrCO2RestoAimData: any = [];
            if (restorationAimsVal && eachKey[1] != undefined && eachKey[1] != null) {
              restorationAimsVal.forEach((ele: any, i: number) => {
                splitArrCO2RestoAimData = Array(eachKey[1]);
                if (splitArrCO2RestoAimData[0].includes(ele.key_)) {
                  splitCO2RestoAimData.push(ele.value);
                }
              });
              eachKey[1] = splitCO2RestoAimData.toString().replaceAll(',', ', ');
            }
          }

          if (eachKey[0] === "jobs_stakeholders") {
            let splitJobStakeholdersData: any = [];
            let splitArrJobStakeholdersData: any = [];
            if (jobStakesholdersVal && eachKey[1] != undefined && eachKey[1] != null) {
              jobStakesholdersVal.forEach((ele: any, i: number) => {
                splitArrJobStakeholdersData = Array(eachKey[1]);
                if (splitArrJobStakeholdersData[0].includes(ele.key_)) {
                  splitJobStakeholdersData.push(ele.value);
                }
              });
              eachKey[1] = splitJobStakeholdersData.toString().replaceAll(',', ', ');
            }
          }

          if (eachKey[0] === "eco_tiers") {
            let splitJobLevelData: any = [];
            let splitArrJobLevelData: any = [];
            if (confidenceLevelVal && eachKey[1] != undefined && eachKey[1] != null) {
              confidenceLevelVal.forEach((ele: any, i: number) => {
                splitArrJobLevelData = Array(eachKey[1]);
                if (splitArrJobLevelData[0].includes(ele.key_)) {
                  splitJobLevelData.push(ele.value);
                }
              });
              eachKey[1] = splitJobLevelData.toString().replaceAll(',', ', ');
            }
          }

          if (eachKey[0] === "pledge_fulfil") {
            eachKey[1] = eachKey[1] === null ? '' : (eachKey[1] == 1 ? t("newReport.restorationPledge.YesFullyTrack") : ((eachKey[1] == 2 ? t("newReport.restorationPledge.YesSomewhatTrack") : ((eachKey[1] === 3 ? t("newReport.restorationPledge.NotTrack") : t("newReport.restorationPledge.InsufficientInformation"))))))
          }

          if (eachKey[0] === "ha_restoration_data") {
            eachKey[1] = eachKey[1] === null ? '' : eachKey[1] == "1" ? "Yes" : (eachKey[1] == "0" ? "No" : "")
          }

          if (eachKey[1] != null && (eachKey[0] === "pledge_start_date" || eachKey[0] === "pledge_end")) {
            if (eachKey[1] == 0) {
              eachKey[1] = '';
            }
            else {
              let dateVal = eachKey[1] as Date;
              eachKey[1] = new Date(dateVal).toLocaleString('default', { month: 'long' }) + ' ' + new Date(dateVal).getFullYear();
            }
          }
          if (eachKey[0] === "location_specific") {
            eachKey[1] = eachKey[1] === null ? '' : eachKey[1] === "0" ? 'No' : ''
          }

          if (eachKey[0] === "action_indicator" || eachKey[0] === "action_indicators") {
            let splitActionData: any = [];
            let splitArrActionData: any = [];
            if (actionVal && eachKey[1] != undefined && eachKey[1] != null) {
              actionVal.forEach((ele: any, i: number) => {
                splitArrActionData = Array(eachKey[1]);
                if (splitArrActionData[0].includes(ele.key_)) {
                  splitActionData.push(ele.value);
                }
              });
              eachKey[1] = splitActionData.toString().replaceAll(',', ', ');
            }
          }

          if (eachKey[0] === "impact_indicator" || eachKey[0] === "impact_indicators") {
            let splitImpactData: any = [];
            let splitArrImpactData: any = [];
            if (impactVal && eachKey[1] != undefined && eachKey[1] != null) {
              impactVal.forEach((ele: any, i: number) => {
                splitArrImpactData = Array(eachKey[1]);
                if (splitArrImpactData[0].includes(ele.key_)) {
                  splitImpactData.push(ele.value);
                }
              });
              eachKey[1] = splitImpactData.toString().replaceAll(',', ', ');
            }
          }
          if (eachKey[0] === "bio_information" && eachKey[1] != undefined && eachKey[1] != null) {
            eachKey[1] = Utils.addSpace(eachKey[1]);
          }

          requestData = eachKey[1] == null ? '' : Utils.removeHTMLTag(eachKey[1])
          requestDataCellRow = [...requestDataCellRow, requestData.replace('&nbsp;', '')];
        }
      });
      excelData = [...excelData, requestDataCellRow];
    }
    return excelData;
  }

  const formatDateValues = async (val: any) => {
    let dateVal = val as Date;
    val = new Date(dateVal).toLocaleString('default', { month: 'long' }) + ' ' + new Date(dateVal).getFullYear();
    return val;
  }

  async function parseMultipleSheetDataToExcel(excelData: any, fileName: any, sheetNames: any) {

    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    sheetNames.map((sheetName: any, index: any) => {
      let excelDataBySheet: any = [];
      // Create a new worksheet
      excelDataBySheet = [excelData[index]]

      let worksheet = XLSX.utils.aoa_to_sheet(excelDataBySheet[0]);

      // Add the worksheet to the workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

      // Apply styles
      var wscols = [];
      var range = XLSX.utils.decode_range(worksheet['!ref']);

      var column_range = range.e.c + 1;

      for (var i = 0; i < column_range; i++) {
        wscols.push({
          wpx: 150
        });
      }

      worksheet['!cols'] = wscols;

      var C, R = range.s.r;
      for (var rowNum = range.s.r; rowNum <= range.e.r; rowNum++) {
        for (var colNum = range.s.c; colNum <= range.e.c; colNum++) {
          if (rowNum == R) {
            var cell = worksheet[XLSX.utils.encode_cell({ c: colNum, r: R })];
            if (typeof cell !== 'undefined') {
              cell.s = {
                font: {
                  name: "Arial",
                  sz: 11,
                  color: { rgb: "FFFFFF" }
                },
                alignment: {
                  wrapText: true
                },
                fill: {
                  patternType: "solid",
                  fgColor: { rgb: "123b60" }
                }
              };
            }
          }
          else {
            var cell = worksheet[XLSX.utils.encode_cell({ r: rowNum, c: colNum })];
            if (typeof cell !== 'undefined') {
              cell.s = {
                font: {
                  name: "Arial",
                  sz: 11,
                },
                alignment: {
                  wrapText: true
                }
              };
            }
          }
        }
      }
    });
    var wbout = XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
    var blob = new Blob([s2ab(wbout)], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" });
    saveAs(blob, fileName);
  }

  function s2ab(s: any) {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
  }


  /**
   * Set save draft loading on / off
   * @param loading
   */
  const setSaveDraftLoading = (loading: boolean) => {
    const obj: any = { ...localState };

    if (obj) {
      obj.isSaveDraftLoading = loading;
      obj.isSubmitLoading = false;
      setLocalState(obj);
    }
  }

  /**
   * Set export loading on / off
   * @param loading
   */
  const setExportLoading = (loading: boolean) => {
    const obj: any = { ...localState };

    if (obj) {
      obj.isExportLoading = loading;
      setLocalState(obj);
    }
  }

  /**
   * Send submit mail
   */
  const sendPSSubmitEmail = async () => {
    try {

      const tab: IGeneralInformationTab | undefined = state.generalInfoTab;
      const focalPointsFeatures: IFeature[] = await QueryService.queryReferenceFeatures(ConfigService.getConfig().agol?.referenceTables.REF_IUCN_FOCAL_POINT_EMAIL.index);
      const selectedFocalPoint: IRefFocalPointFeature | undefined = focalPointsFeatures.map((feat: IFeature) => feat.attributes as IRefFocalPointFeature).find((i: IRefFocalPointFeature) => i.key_ === tab?.email);
      //const selectedFocalPoint: any = tab?.email?.toString();
      QueryService.sendPSSubmitMail(selectedFocalPoint?.value, state.generalInfoTab?.company_name!, state.report!.attributes[ConfigService.getConfig().agol?.operationalLayers.reportMain.fields.repYear || '']);
      //QueryService.sendPSSubmitMail(selectedFocalPoint!, state.generalInfoTab?.company_name!, state.report!.attributes[ConfigService.getConfig().agol?.operationalLayers.reportMain.fields.repYear || '']);

      return Promise.resolve();
    } catch (err: any) {
      console.log(err);
      return Promise.reject(err);
    }
  }

  /**
   * Handle submit
   */
  const onSubmit = async () => {
    try {
      setSubmitLoading(true);
      const res: any = await callSaveData(true);
      setSubmitLoading(false);
      toast.success(t('newReport.submitSuccess'));

      // Send email
      await sendPSSubmitEmail();

      // Go to reports list page
      goToReportsListPage();

    } catch (err: any) {
      setSubmitLoading(false);
      toast.error(t('newReport.submitError'));
    }
  }

  /**
  * Set submit loading on / off
  * @param loading
  */
  const setSubmitLoading = (loading: boolean) => {
    const obj: any = { ...localState };

    if (obj) {
      obj.isSaveDraftLoading = false;
      obj.isSubmitLoading = loading;
      setLocalState(obj);
    }
  }

  const forceUpdate = useForceUpdate();
  return (
    <>
      {state.userLoaded ?

        state.report && state.report.attributes ?
          <div className="editReportDiv wrapper">

            {(state.report.attributes.published && !IsViewUser) ?
              <div className="editReportContent">
                <span className="textError">{t('newReport.alreadySubmittedPublishedReport')}</span>
              </div>

              :

              <div className="editReportContent">
                {(localState.isOpen) && (
                  <div>
                    <div>
                      <PSPrivacyPopupSplash opened={localState.isOpen} ></PSPrivacyPopupSplash>
                    </div>
                  </div>
                )}
                <div>
                  {/* <span className="pageTitle bigText">
                    {state.report.attributes[ConfigService.getConfig().agol?.operationalLayers.reportMain.fields.name0 || '']}
                    {state.report.attributes[ConfigService.getConfig().agol?.operationalLayers.reportMain.fields.name1 || ''] && ' - ' + state.report.attributes[ConfigService.getConfig().agol?.operationalLayers.reportMain.fields.name1 || '']}
                    {' - '}
                    {state.report.attributes[ConfigService.getConfig().agol?.operationalLayers.reportMain.fields.repYear || '']}
                  </span> */}

                  <span className="pageTitle bigText">
                    {state.report.attributes[ConfigService.getConfig().agol?.operationalLayers.reportMain.fields.companyName || '']}
                    {' - '}
                    {state.report.attributes[ConfigService.getConfig().agol?.operationalLayers.reportMain.fields.repYear || '']}
                  </span>
                  <span className="spn1t">
                    <span className="img1tlogo"></span>
                  </span>

                  <div className='buttonsDiv'>
                    <button className="actionBtn secondary" onClick={() => handleExitDialogShow()}>
                      <span>{t('newReport.close')}</span>
                    </button>

                    <button className="actionBtn secondary" disabled={IsViewUser} onClick={onSaveDraft} onMouseOver={() => draftMouseOver(true)} onMouseOut={() => draftMouseOver(false)}>
                      <span>{t('newReport.saveDraft')}</span>
                    </button>

                    <button className="actionBtn primary" onClick={handleSubmitReportDialogShow} disabled={IsViewUser || !state || !state.generalInfoTab?.isOK || !state.restorationPledgeTrackingTab?.isOK || !state.restorationPledgeTrackingDetailsTab?.isOK}>
                      <span>{t('newReport.submit')}</span>
                    </button>

                    <button className="actionBtn secondary" onClick={callExport} onMouseOver={() => draftMouseOver(true)} onMouseOut={() => draftMouseOver(false)}>
                      <span>{t('newReport.export')}</span>
                    </button>

                  </div>
                </div>

                <div className="tabs">

                  <div className={`tabItem ${state.generalInfoTab && state.generalInfoTab?.isActive ? 'active' : state.generalInfoTab && state.generalInfoTab?.isOK ? 'ok' : 'default'}`}
                    onClick={() => selectTab(0)}>
                    <span className="tabSpan">{t('newReport.generalInfo.label')}</span>
                    <FontAwesomeIcon className="tabIcon checkIcon" icon={faCheck} />
                    <FontAwesomeIcon className="tabIcon closeIcon" icon={faTimes} />
                  </div>

                  <div className={`tabItem ${state.restorationPledgeTrackingTab && state.restorationPledgeTrackingTab?.isActive ? 'active' : state.restorationPledgeTrackingTab && state.restorationPledgeTrackingTab?.isOK ? 'ok' : 'default'}`}
                    onClick={() => selectTab(1)}>
                    <span className="tabSpan restabSpan">{t('newReport.restorationPledge.label')}</span>
                    <FontAwesomeIcon className="tabIcon checkIcon tickPledgeimp" icon={faCheck} />
                    <FontAwesomeIcon className="tabIcon closeIcon resCloseIcon" icon={faTimes} />
                  </div>
                  <div className={`tabItem ${state.restorationPledgeTrackingDetailsTab && state.restorationPledgeTrackingDetailsTab?.isActive ? 'active' : state.restorationPledgeTrackingDetailsTab && state.restorationPledgeTrackingDetailsTab?.isOK ? 'ok' : 'default'}`}
                    onClick={() => selectTab(2)}>
                    <span className="tabSpan restabSpan">{t('newReport.restorationPledgeDetails.label')}</span>
                    <FontAwesomeIcon className="tabIcon checkIcon tickPledgeimp" icon={faCheck} />
                    <FontAwesomeIcon className="tabIcon closeIcon resCloseIcon" icon={faTimes} />
                  </div>

                  <div className={`tabItem ${state.privateSectorSuccessFactorsTab && state.privateSectorSuccessFactorsTab?.isActive ? 'active' : !state.privateSectorSuccessFactorsTab?.isActive && !state.privateSectorSuccessFactorsTab?.isDisabled && state.privateSectorSuccessFactorsTab?.isOK ? 'ok' : state.privateSectorSuccessFactorsTab && state.privateSectorSuccessFactorsTab?.isDisabled ? 'default disabled' : 'default'}`}
                    onClick={() => selectTab(3)}>
                    <span className="tabSpan">{t('newReport.successFactors.label')}</span>
                    <FontAwesomeIcon className="tabIcon checkIcon" icon={faCheck} />
                    <FontAwesomeIcon className="tabIcon closeIcon" icon={faTimes} />
                  </div>

                  <div className={`tabItem ${state.privateSectorResultsAndBenefitsTab && (state.privateSectorResultsAndBenefitsTab?.isActive) ? 'active' : state.privateSectorResultsAndBenefitsTab && state.privateSectorResultsAndBenefitsTab?.isOK ? 'ok' : 'default'}`}
                    onClick={() => selectTab(4)}>
                    <span className="tabSpan">{t('newReport.resultsAndBenefits.label')}</span>
                    <FontAwesomeIcon className="tabIcon checkIcon" icon={faCheck} />
                    <FontAwesomeIcon className="tabIcon closeIcon" icon={faTimes} />
                  </div>
                </div>

                <div className="tabsContent" style={{ backgroundImage: `url("${process.env.PUBLIC_URL}/assets/background/edit-report-bg.svg")` }}>

                  {state.generalInfoTab && state.generalInfoTab?.isActive &&
                    <div className="wrapper">
                      <GeneralInformationTab state={state} setState={setState}
                        validateData={validateGeneralInfoData} />
                    </div>
                  }

                  {state.restorationPledgeTrackingTab && state.restorationPledgeTrackingTab?.isActive &&
                    <div className="wrapper">
                      <SectorRestorationPledge state={state} setState={setState} validateData={validateRestorationPledgeTrackingData} />
                    </div>
                  }

                  {state.restorationPledgeTrackingDetailsTab && state.restorationPledgeTrackingDetailsTab?.isActive &&
                    <div className="wrapper">
                      <SectorRestorationPledgeDetails state={state} setState={setState} validateData={validateRestorationPledgeTrackingDetailData} />
                    </div>
                  }

                  {state.privateSectorSuccessFactorsTab && state.privateSectorSuccessFactorsTab?.isActive &&
                    <div className="wrapper">
                      <SectorSuccessFactors state={state} setState={setState} validateData={validateSuccessFactorsData} />
                    </div>
                  }

                  {state.privateSectorResultsAndBenefitsTab && state.privateSectorResultsAndBenefitsTab?.isActive &&
                    <div className="wrapper">
                      <SectorResultsAndBenefits state={state} setState={setState} validateData={validateResultsAndBenefitsTab} content='' />
                    </div>
                  }
                </div>
              </div>
            }

            <ToastContainer
              position="bottom-center"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover />

            <Modal show={exitDialog} onHide={handleExitDialogClose}>
              <Modal.Header closeButton>
                <Modal.Title>{t('newReport.closeEditionTitle')}</Modal.Title>
              </Modal.Header>
              <Modal.Body>{t('newReport.closeEditionContent')}</Modal.Body>
              <Modal.Footer>
                <button className="dialogBtn secondary" onClick={handleExitDialogClose}>
                  {t('newReport.closeEditionCancel')}
                </button>
                <button className="dialogBtn primary" onClick={handleExitConfirm}>
                  {t('newReport.closeEditionConfirm')}
                </button>
              </Modal.Footer>
            </Modal>

            <Modal show={submitReportDialog} onHide={handleSubmitReportDialogClose}>
              <Modal.Header closeButton>
                <Modal.Title>{t('newReport.confirmSubmitTitle')}</Modal.Title>
              </Modal.Header>
              <Modal.Body>{t('newReport.confirmSubmitContent')}</Modal.Body>
              <Modal.Footer>
                <button className="dialogBtn secondary" onClick={handleSubmitReportDialogClose}>
                  {t('newReport.confirmSubmitCancel')}
                </button>
                <button className="dialogBtn primary" onClick={handleSubmitReportConfirm}>
                  {t('newReport.confirmSubmitYes')}
                </button>
              </Modal.Footer>
            </Modal>

            <LoadingOverlay
              active={localState.isSaveDraftLoading || localState.isSubmitLoading}
              spinner
              text={localState.isSaveDraftLoading ? t('newReport.savingDraft') : localState.isSubmitLoading ? t('newReport.savingReport') : ''}>
            </LoadingOverlay>

            <LoadingOverlay
              active={localState.isFetchingReportData}
              spinner
              text={localState.isFetchingReportData ? t('newReport.fetchingReportData') : ''}>
            </LoadingOverlay>
          </div>

          : state.reportLoaded && !state.report ? <span className="textError reportNotExist">{t('newReport.reportNotExist')}</span> : <span></span>

        : <Redirect to={ConfigService.getConfig().routes?.login || ''} />
      }

      <LoadingOverlay
        active={localState.isFetchingReportData}
        spinner
        text={localState.isFetchingReportData ? t('newReport.fetchingReportData') : ''}>
      </LoadingOverlay>
    </>

  );
};
export default SectorEditReport;

